/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
};

export type ActiveBannerInput = {
  bannerId: Scalars['Float']['input'];
};

export type ActiveBannerOptionInput = {
  bannerOptionId: Scalars['Float']['input'];
};

export type ActiveBannerOptionOutput = {
  __typename?: 'ActiveBannerOptionOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ActiveBannerOutput = {
  __typename?: 'ActiveBannerOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type Address = {
  __typename?: 'Address';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Float']['output'];
  isRep: Scalars['Boolean']['output'];
  mainAddress?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pass?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Port>;
  region?: Maybe<Scalars['String']['output']>;
  subAddress?: Maybe<Scalars['String']['output']>;
  user: User;
  username?: Maybe<Scalars['String']['output']>;
  zoneCode?: Maybe<Scalars['String']['output']>;
};

export type Banner = {
  __typename?: 'Banner';
  bannerMain?: Maybe<Array<BannerMain>>;
  bannerOptions?: Maybe<Array<BannerOption>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type BannerMain = {
  __typename?: 'BannerMain';
  alt?: Maybe<Scalars['String']['output']>;
  banner?: Maybe<Banner>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  event?: Maybe<BannerMainEvent>;
  id: Scalars['Float']['output'];
  index: Scalars['Float']['output'];
  isEvent: Scalars['Boolean']['output'];
  isFree: Scalars['Boolean']['output'];
  isOnePlusOne: Scalars['Boolean']['output'];
  isRes: Scalars['Boolean']['output'];
  link?: Maybe<Scalars['String']['output']>;
  linkServices?: Maybe<Array<LinkService>>;
  mainType?: Maybe<BannerMainType>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  upload?: Maybe<Upload>;
};

export type BannerMainEvent = {
  __typename?: 'BannerMainEvent';
  bannerMain?: Maybe<BannerMain>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  link?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  upload?: Maybe<Upload>;
};

export enum BannerMainType {
  Image = 'Image',
  Video = 'Video'
}

export type BannerOption = {
  __typename?: 'BannerOption';
  alt?: Maybe<Scalars['String']['output']>;
  banner?: Maybe<Banner>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Float']['output'];
  index: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  isEvent: Scalars['Boolean']['output'];
  isFree: Scalars['Boolean']['output'];
  isOnePlusOne: Scalars['Boolean']['output'];
  isRes: Scalars['Boolean']['output'];
  link?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  upload?: Maybe<Upload>;
};

export type BasketItem = {
  __typename?: 'BasketItem';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  good: Good;
  goodOption?: Maybe<GoodOption>;
  id: Scalars['Float']['output'];
  isBasket?: Maybe<Scalars['Boolean']['output']>;
  quantity: Scalars['Float']['output'];
  receipt?: Maybe<Receipt>;
  user: User;
};

export type CancelOrderInput = {
  orderId: Scalars['Float']['input'];
};

export type CancelOrderOutput = {
  __typename?: 'CancelOrderOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CancelOrdersInput = {
  orderIds: Array<Scalars['Float']['input']>;
};

export type CancelOrdersOutput = {
  __typename?: 'CancelOrdersOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ChangeActiveInput = {
  corporationId: Scalars['Float']['input'];
};

export type ChangeActiveOutput = {
  __typename?: 'ChangeActiveOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ChangeOrderOutput = {
  __typename?: 'ChangeOrderOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ChangeOutput = {
  __typename?: 'ChangeOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ChangeServiceActiveInput = {
  serviceId: Scalars['Float']['input'];
};

export type ChangeServiceActiveOutput = {
  __typename?: 'ChangeServiceActiveOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ChkAddressAreaInput = {
  region?: InputMaybe<Scalars['String']['input']>;
};

export type ChkAddressAreaOutput = {
  __typename?: 'ChkAddressAreaOutput';
  deliveryArea?: Maybe<Scalars['Boolean']['output']>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type Comment = {
  __typename?: 'Comment';
  author: User;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Float']['output'];
  inquiry: Inquiry;
  note: Scalars['String']['output'];
};

export type ConfirmOrderKioskInput = {
  orderId: Scalars['Float']['input'];
  simplePassword: Scalars['String']['input'];
};

export type ConfirmOrderKioskOutput = {
  __typename?: 'ConfirmOrderKioskOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type CoreOutput = {
  __typename?: 'CoreOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type Corporation = {
  __typename?: 'Corporation';
  address?: Maybe<Scalars['String']['output']>;
  amount: Scalars['Float']['output'];
  author?: Maybe<User>;
  businessAddress?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  businessNumber?: Maybe<Scalars['String']['output']>;
  ceoName?: Maybe<Scalars['String']['output']>;
  coupons?: Maybe<Array<Coupon>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deliveryLimitQuantity?: Maybe<Scalars['Float']['output']>;
  goodOptions?: Maybe<Array<GoodOption>>;
  goods?: Maybe<Array<Good>>;
  holiday?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  isManualActive: Scalars['Boolean']['output'];
  linkService?: Maybe<LinkService>;
  mainCategories?: Maybe<Array<MainCategory>>;
  managerName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  operationFrom?: Maybe<Scalars['String']['output']>;
  operationTo?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  regionKeyWord?: Maybe<Array<Scalars['String']['output']>>;
  subCategories?: Maybe<Array<SubCategory>>;
};

export type Coupon = {
  __typename?: 'Coupon';
  code?: Maybe<Scalars['String']['output']>;
  corporation?: Maybe<Corporation>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  linkService?: Maybe<LinkService>;
  name: Scalars['String']['output'];
  scope: CouponScope;
  status: CouponStatus;
  usageLimit: Scalars['Float']['output'];
  userCoupons?: Maybe<Array<UserCoupon>>;
  userUsageLimit: Scalars['Float']['output'];
  validFrom: Scalars['DateTime']['output'];
  validUntil: Scalars['DateTime']['output'];
};

export enum CouponScope {
  Corporation = 'CORPORATION',
  Global = 'GLOBAL',
  LinkService = 'LINK_SERVICE'
}

export enum CouponStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Inactive = 'INACTIVE'
}

export type CouponWithAvailability = {
  __typename?: 'CouponWithAvailability';
  coupon: Coupon;
  isAvailable: Scalars['Boolean']['output'];
  unavailableReason?: Maybe<Scalars['String']['output']>;
  userCouponId?: Maybe<Scalars['Float']['output']>;
  userCouponStatus?: Maybe<UserCouponStatus>;
};

export type CrAddressInput = {
  isRep: Scalars['Boolean']['input'];
  mainAddress?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pass?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  subAddress?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  zoneCode?: InputMaybe<Scalars['String']['input']>;
};

export type CrAddressOutput = {
  __typename?: 'CrAddressOutput';
  addressId?: Maybe<Scalars['Float']['output']>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrBannerInput = {
  title: Scalars['String']['input'];
};

export type CrBannerMainInput = {
  index?: InputMaybe<Scalars['Float']['input']>;
  linkServiceId?: InputMaybe<Scalars['Float']['input']>;
  mainType: BannerMainType;
};

export type CrBannerMainOutput = {
  __typename?: 'CrBannerMainOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrBannerOptionOutput = {
  __typename?: 'CrBannerOptionOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrBannerOutput = {
  __typename?: 'CrBannerOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrBasketItemInput = {
  basketInfos?: InputMaybe<Array<DetailCrBasketInput>>;
};

export type CrBasketItemOutput = {
  __typename?: 'CrBasketItemOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrCommentInput = {
  inquiryId: Scalars['Float']['input'];
  note: Scalars['String']['input'];
};

export type CrCommentOutput = {
  __typename?: 'CrCommentOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrCorporationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  deliveryLimitQuantity?: InputMaybe<Scalars['Float']['input']>;
  holiday?: InputMaybe<Scalars['String']['input']>;
  mainCategoryNames?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  operationFrom?: InputMaybe<Scalars['String']['input']>;
  operationTo?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  serviceId?: InputMaybe<Scalars['Float']['input']>;
};

export type CrCorporationOutput = {
  __typename?: 'CrCorporationOutput';
  createdId: Scalars['Float']['output'];
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrCouponInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  corporationId?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountPrice?: InputMaybe<Scalars['Float']['input']>;
  linkServiceId?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  scope: CouponScope;
  status: CouponStatus;
  usageLimit?: InputMaybe<Scalars['Float']['input']>;
  userUsageLimit?: InputMaybe<Scalars['Float']['input']>;
  validFrom: Scalars['DateTime']['input'];
  validUntil: Scalars['DateTime']['input'];
};

export type CrCouponOutput = {
  __typename?: 'CrCouponOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrDefaultPocketInput = {
  direction: Scalars['Float']['input'];
  portId: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type CrDefaultPocketOutput = {
  __typename?: 'CrDefaultPocketOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrDroneInput = {
  model: DroneModel;
  name: Scalars['String']['input'];
  serial?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DroneStatus>;
};

export type CrDroneOutput = {
  __typename?: 'CrDroneOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrFlightInput = {
  droneId: Scalars['Float']['input'];
  landAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  orderAt?: InputMaybe<Scalars['DateTime']['input']>;
  packId?: InputMaybe<Scalars['Float']['input']>;
  pilotFromId?: InputMaybe<Scalars['Float']['input']>;
  pilotToId?: InputMaybe<Scalars['Float']['input']>;
  portFromId: Scalars['Float']['input'];
  portToId: Scalars['Float']['input'];
  projectId: Scalars['Float']['input'];
  status?: InputMaybe<FlightStatus>;
  takeOffAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CrFlightOutput = {
  __typename?: 'CrFlightOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrGoodBulkElement = {
  discountRate?: InputMaybe<Scalars['Float']['input']>;
  optionName: Scalars['String']['input'];
  plu?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type CrGoodBulkInput = {
  goods: Array<CrGoodBulkElement>;
};

export type CrGoodBulkOutput = {
  __typename?: 'CrGoodBulkOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrGoodDetailInput = {
  detailType: GoodDetailType;
  goodId: Scalars['Float']['input'];
  index?: InputMaybe<Scalars['Float']['input']>;
};

export type CrGoodDetailOutput = {
  __typename?: 'CrGoodDetailOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrGoodInput = {
  corporationId?: InputMaybe<Scalars['Float']['input']>;
  discountRate?: InputMaybe<Scalars['Float']['input']>;
  expirydate?: InputMaybe<Scalars['DateTime']['input']>;
  limitNumOrders?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  status: Scalars['String']['input'];
  subCategoryName?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Tags>>;
  title: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type CrGoodOptionInput = {
  goodId?: InputMaybe<Scalars['Float']['input']>;
};

export type CrGoodOptionOutput = {
  __typename?: 'CrGoodOptionOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrGoodOutput = {
  __typename?: 'CrGoodOutput';
  createdId: Scalars['Float']['output'];
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrGoodPosterInput = {
  goodId: Scalars['Float']['input'];
  index?: InputMaybe<Scalars['Float']['input']>;
};

export type CrGoodPosterOutput = {
  __typename?: 'CrGoodPosterOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrGoodReviewInput = {
  goodReviewPosterIds: Array<Scalars['Float']['input']>;
  note: Scalars['String']['input'];
  orderId: Scalars['Float']['input'];
  rating: Scalars['Float']['input'];
};

export type CrGoodReviewPosterInput = {
  imageUuid?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
};

export type CrGoodReviewPosterOutput = {
  __typename?: 'CrGoodReviewPosterOutput';
  err?: Maybe<Scalars['String']['output']>;
  goodReviewPoster?: Maybe<GoodReviewPoster>;
  ok: Scalars['Boolean']['output'];
};

export type CrInquiryInput = {
  inquiryPosters?: InputMaybe<Array<Scalars['Float']['input']>>;
  note: Scalars['String']['input'];
  receiptId?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<InquiryType>;
};

export type CrInquiryOutput = {
  __typename?: 'CrInquiryOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrInquiryPosterInput = {
  imageUuid?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Float']['input']>;
};

export type CrInquiryPosterOutput = {
  __typename?: 'CrInquiryPosterOutput';
  err?: Maybe<Scalars['String']['output']>;
  inquiryPoster?: Maybe<InquiryPoster>;
  ok: Scalars['Boolean']['output'];
};

export type CrLinkServiceInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minAmount?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  operationFrom?: InputMaybe<Scalars['String']['input']>;
  operationTo?: InputMaybe<Scalars['String']['input']>;
  useDeliveryFee?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CrLinkServiceOutput = {
  __typename?: 'CrLinkServiceOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrMainCategoryInput = {
  imageUuid?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CrMainCategoryOutput = {
  __typename?: 'CrMainCategoryOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrOrderReceiptOutput = {
  __typename?: 'CrOrderReceiptOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrPackInput = {
  orderIds?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type CrPackOutput = {
  __typename?: 'CrPackOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  pack?: Maybe<Pack>;
};

export type CrPortInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['Float']['input']>;
  serviceId?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<PortStatus>;
};

export type CrPortOutput = {
  __typename?: 'CrPortOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrProjectInput = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  note: Scalars['String']['input'];
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CrProjectOutput = {
  __typename?: 'CrProjectOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrReceiptInput = {
  basketItemIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  buyInfos?: InputMaybe<Array<DetailCrReceiptInput>>;
};

export type CrReceiptOutput = {
  __typename?: 'CrReceiptOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  receipt?: Maybe<Receipt>;
};

export type CrSnsUserInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sns?: InputMaybe<Sns>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CrSnsUserOutput = {
  __typename?: 'CrSnsUserOutput';
  err?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  ok: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type CrStaffUserInput = {
  linkServiceIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  role: UserRole;
  username: Scalars['String']['input'];
  workerType?: InputMaybe<WorkerType>;
};

export type CrStaffUserOutput = {
  __typename?: 'CrStaffUserOutput';
  err?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrUserCouponInput = {
  couponId: Scalars['Float']['input'];
  userId: Scalars['Float']['input'];
};

export type CrUserCouponOutput = {
  __typename?: 'CrUserCouponOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrUserInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  workerType?: InputMaybe<WorkerType>;
};

export type CrUserOutput = {
  __typename?: 'CrUserOutput';
  err?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type CrgoodReviewOutput = {
  __typename?: 'CrgoodReviewOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelAddressInput = {
  id: Scalars['Float']['input'];
};

export type DelAddressOutput = {
  __typename?: 'DelAddressOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelBannerInput = {
  bannerId: Scalars['Float']['input'];
};

export type DelBannerMainInput = {
  bannerMainId: Scalars['Float']['input'];
};

export type DelBannerMainOutput = {
  __typename?: 'DelBannerMainOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelBannerOutput = {
  __typename?: 'DelBannerOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelBasketItemInput = {
  basketItemIds: Array<Scalars['Float']['input']>;
};

export type DelBasketItemOutput = {
  __typename?: 'DelBasketItemOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelCommentInput = {
  commentId: Scalars['Float']['input'];
};

export type DelCommentOutput = {
  __typename?: 'DelCommentOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelCorporationInput = {
  corporationId: Scalars['Float']['input'];
};

export type DelCorporationOutput = {
  __typename?: 'DelCorporationOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelCouponInput = {
  couponId?: InputMaybe<Scalars['Float']['input']>;
};

export type DelCouponOutput = {
  __typename?: 'DelCouponOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelDroneInput = {
  droneId: Scalars['Float']['input'];
};

export type DelDroneOutput = {
  __typename?: 'DelDroneOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelFlightInput = {
  flightId: Scalars['Float']['input'];
};

export type DelFlightOutput = {
  __typename?: 'DelFlightOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelGoodDetailInput = {
  goodDetailId: Scalars['Float']['input'];
};

export type DelGoodDetailOutput = {
  __typename?: 'DelGoodDetailOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelGoodInput = {
  goodId: Scalars['Float']['input'];
};

export type DelGoodOptionInput = {
  goodOptionId: Scalars['Float']['input'];
};

export type DelGoodOptionOutput = {
  __typename?: 'DelGoodOptionOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelGoodOutput = {
  __typename?: 'DelGoodOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelGoodPosterInput = {
  goodPosterId: Scalars['Float']['input'];
};

export type DelGoodPosterOutput = {
  __typename?: 'DelGoodPosterOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelGoodReviewInput = {
  reviewId: Scalars['Float']['input'];
};

export type DelGoodReviewOutput = {
  __typename?: 'DelGoodReviewOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelGoodReviewPosterInput = {
  reviewPosterId: Scalars['Float']['input'];
};

export type DelGoodReviewPosterOutput = {
  __typename?: 'DelGoodReviewPosterOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelInquiryInput = {
  inquiryId: Scalars['Float']['input'];
};

export type DelInquiryOutput = {
  __typename?: 'DelInquiryOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelInquiryPosterInput = {
  inquiryPosterId: Scalars['Float']['input'];
};

export type DelInquiryPosterOutput = {
  __typename?: 'DelInquiryPosterOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelLinkServiceInput = {
  linkServiceId: Scalars['Float']['input'];
};

export type DelLinkServiceOutput = {
  __typename?: 'DelLinkServiceOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelMainCategoryInput = {
  id: Scalars['Float']['input'];
};

export type DelMainCategoryOutput = {
  __typename?: 'DelMainCategoryOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelOrderInput = {
  orderId: Scalars['Float']['input'];
};

export type DelOrderOutput = {
  __typename?: 'DelOrderOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelPackInput = {
  packId?: InputMaybe<Scalars['Float']['input']>;
};

export type DelPackOrderInput = {
  orderId: Scalars['Float']['input'];
};

export type DelPackOrderOutput = {
  __typename?: 'DelPackOrderOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelPackOutput = {
  __typename?: 'DelPackOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelPortInput = {
  portId: Scalars['Float']['input'];
};

export type DelPortOutput = {
  __typename?: 'DelPortOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelProjectInput = {
  projectId?: InputMaybe<Scalars['Float']['input']>;
};

export type DelProjectOutput = {
  __typename?: 'DelProjectOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DelUserInput = {
  id: Scalars['Float']['input'];
};

export type DelUserOutput = {
  __typename?: 'DelUserOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type DetailCrBasketInput = {
  goodId?: InputMaybe<Scalars['Float']['input']>;
  goodOptionId?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type DetailCrReceiptInput = {
  goodId?: InputMaybe<Scalars['Float']['input']>;
  goodOptionId?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type DetailedGoodOptionInput = {
  count?: InputMaybe<Scalars['Float']['input']>;
  dateActive?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  discountRate?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Float']['input'];
  isEvent?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type Drone = {
  __typename?: 'Drone';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  flights?: Maybe<Array<Flight>>;
  id: Scalars['Float']['output'];
  model: DroneModel;
  name: Scalars['String']['output'];
  serial?: Maybe<Scalars['String']['output']>;
  status: DroneStatus;
};

export enum DroneModel {
  Af200 = 'AF200',
  Ds30 = 'DS30',
  Gd23Ot = 'GD23OT',
  P01 = 'P01',
  P05 = 'P05',
  Pandion = 'PANDION',
  Phv20 = 'PHV20'
}

export enum DroneStatus {
  Damage = 'Damage',
  Operating = 'Operating',
  Pending = 'Pending',
  Repair = 'Repair',
  Testing = 'Testing'
}

export type EditBannerInput = {
  bannerId: Scalars['Float']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EditBannerMainIndexInput = {
  bannerMainId: Scalars['Float']['input'];
  index: Scalars['Float']['input'];
};

export type EditBannerMainIndexOutput = {
  __typename?: 'EditBannerMainIndexOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditBannerMainInput = {
  alt?: InputMaybe<Scalars['String']['input']>;
  bannerMainId: Scalars['Float']['input'];
  eventActive?: InputMaybe<Scalars['Boolean']['input']>;
  eventLink?: InputMaybe<Scalars['String']['input']>;
  eventTitle?: InputMaybe<Scalars['String']['input']>;
  eventUuid?: InputMaybe<Scalars['String']['input']>;
  isEvent?: InputMaybe<Scalars['Boolean']['input']>;
  isFree?: InputMaybe<Scalars['Boolean']['input']>;
  isOnePlusOne?: InputMaybe<Scalars['Boolean']['input']>;
  isRes?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  viewUuid?: InputMaybe<Scalars['String']['input']>;
};

export type EditBannerMainOutput = {
  __typename?: 'EditBannerMainOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditBannerOptionInput = {
  alt?: InputMaybe<Scalars['String']['input']>;
  bannerId: Scalars['Float']['input'];
  isEvent?: InputMaybe<Scalars['Boolean']['input']>;
  isFree?: InputMaybe<Scalars['Boolean']['input']>;
  isOnePlusOne?: InputMaybe<Scalars['Boolean']['input']>;
  isRes?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  viewUuid?: InputMaybe<Scalars['String']['input']>;
};

export type EditBannerOptionOutput = {
  __typename?: 'EditBannerOptionOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditBannerOutput = {
  __typename?: 'EditBannerOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditBusinessInfoInput = {
  businessAddress: Scalars['String']['input'];
  businessName: Scalars['String']['input'];
  businessNumber: Scalars['String']['input'];
  ceoName: Scalars['String']['input'];
  corporationId: Scalars['Float']['input'];
};

export type EditBusinessInfoOutput = {
  __typename?: 'EditBusinessInfoOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditCommentInput = {
  commentId: Scalars['Float']['input'];
  note: Scalars['String']['input'];
};

export type EditCommentOutput = {
  __typename?: 'EditCommentOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditCorporationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  corporationId: Scalars['Float']['input'];
  deliveryLimitQuantity?: InputMaybe<Scalars['Float']['input']>;
  holiday?: InputMaybe<Scalars['String']['input']>;
  mainCategoryNames?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  operationFrom?: InputMaybe<Scalars['String']['input']>;
  operationTo?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  serviceId?: InputMaybe<Scalars['Float']['input']>;
};

export type EditCorporationOutput = {
  __typename?: 'EditCorporationOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditCouponInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  corporationId?: InputMaybe<Scalars['Float']['input']>;
  couponId?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountPrice?: InputMaybe<Scalars['Float']['input']>;
  linkServiceId?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  scope: CouponScope;
  status?: InputMaybe<CouponStatus>;
  usageLimit: Scalars['Float']['input'];
  userUsageLimit?: InputMaybe<Scalars['Float']['input']>;
  validFrom: Scalars['DateTime']['input'];
  validUntil: Scalars['DateTime']['input'];
};

export type EditCouponOutput = {
  __typename?: 'EditCouponOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditDroneInput = {
  droneId: Scalars['Float']['input'];
  model: DroneModel;
  name: Scalars['String']['input'];
  serial?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DroneStatus>;
};

export type EditDroneOutput = {
  __typename?: 'EditDroneOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditExchangeStatusInput = {
  exchangeStatus: ExchangeStatus;
  orderId: Scalars['Float']['input'];
};

export type EditExchangeStatusOutput = {
  __typename?: 'EditExchangeStatusOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditFlightInput = {
  droneId: Scalars['Float']['input'];
  flightId: Scalars['Float']['input'];
  landAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  orderAt?: InputMaybe<Scalars['DateTime']['input']>;
  packId?: InputMaybe<Scalars['Float']['input']>;
  pilotFromId?: InputMaybe<Scalars['Float']['input']>;
  pilotToId?: InputMaybe<Scalars['Float']['input']>;
  portFromId: Scalars['Float']['input'];
  portToId: Scalars['Float']['input'];
  projectId: Scalars['Float']['input'];
  status?: InputMaybe<FlightStatus>;
  takeOffAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EditFlightOutput = {
  __typename?: 'EditFlightOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditFlightStatusInput = {
  flightId: Scalars['Float']['input'];
  status?: InputMaybe<FlightStatus>;
};

export type EditFlightStatusOutput = {
  __typename?: 'EditFlightStatusOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditGoodAttrInfoInput = {
  goodAttrInfo?: InputMaybe<Scalars['String']['input']>;
  goodId: Scalars['Float']['input'];
};

export type EditGoodAttrInfoOutput = {
  __typename?: 'EditGoodAttrInfoOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditGoodAttrInput = {
  attributeSet?: InputMaybe<Scalars['String']['input']>;
  goodId: Scalars['Float']['input'];
};

export type EditGoodAttrOutput = {
  __typename?: 'EditGoodAttrOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditGoodDetailIndexInput = {
  goodDetailId: Scalars['Float']['input'];
  index: Scalars['Float']['input'];
};

export type EditGoodDetailIndexOutput = {
  __typename?: 'EditGoodDetailIndexOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditGoodDetailInput = {
  goodDetailId: Scalars['Float']['input'];
  imageUuid?: InputMaybe<Scalars['String']['input']>;
  index: Scalars['Float']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type EditGoodDetailOutput = {
  __typename?: 'EditGoodDetailOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditGoodInput = {
  corporationId?: InputMaybe<Scalars['Float']['input']>;
  discountRate?: InputMaybe<Scalars['Float']['input']>;
  expirydate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  limitNumOrders?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<GoodStatus>;
  subCategoryName?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Tags>>;
  title?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type EditGoodOptionInput = {
  detailedGoodOptions?: InputMaybe<Array<DetailedGoodOptionInput>>;
};

export type EditGoodOptionOutput = {
  __typename?: 'EditGoodOptionOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditGoodOrderInput = {
  goodId: Scalars['Float']['input'];
  goodOrder: GoodOrder;
};

export type EditGoodOrderOutput = {
  __typename?: 'EditGoodOrderOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditGoodOutput = {
  __typename?: 'EditGoodOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditGoodPosterInput = {
  goodPosterId: Scalars['Float']['input'];
  imageUuid: Scalars['String']['input'];
  index: Scalars['Float']['input'];
  isRep?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EditGoodPosterOutput = {
  __typename?: 'EditGoodPosterOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditGoodReviewInput = {
  goodReviewPosterIds: Array<Scalars['Float']['input']>;
  note: Scalars['String']['input'];
  rating: Scalars['Float']['input'];
  reviewId: Scalars['Float']['input'];
};

export type EditGoodStatusInput = {
  goodId: Scalars['Float']['input'];
  status: GoodStatus;
};

export type EditGoodStatusOutput = {
  __typename?: 'EditGoodStatusOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditGoodsStatusInput = {
  goodIds: Array<Scalars['Float']['input']>;
  status: GoodStatus;
};

export type EditGoodsStatusOutput = {
  __typename?: 'EditGoodsStatusOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditInquiryInput = {
  inquiryId: Scalars['Float']['input'];
  inquiryPosters?: InputMaybe<Array<Scalars['Float']['input']>>;
  note: Scalars['String']['input'];
  receiptId?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<InquiryType>;
};

export type EditInquiryOutput = {
  __typename?: 'EditInquiryOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditInquiryStatusInput = {
  inquiryId: Scalars['Float']['input'];
  status?: InputMaybe<InquiryStatus>;
};

export type EditInquiryStatusOutput = {
  __typename?: 'EditInquiryStatusOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditLinkServiceInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  linkServiceId: Scalars['Float']['input'];
  minAmount?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  operationFrom?: InputMaybe<Scalars['String']['input']>;
  operationTo?: InputMaybe<Scalars['String']['input']>;
  useDeliveryFee?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EditLinkServiceOutput = {
  __typename?: 'EditLinkServiceOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditMainCategoryInput = {
  id: Scalars['Float']['input'];
  imageUuid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EditMainCategoryOutput = {
  __typename?: 'EditMainCategoryOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditNotificationSettingInput = {
  adminNotifyPhone?: InputMaybe<Scalars['String']['input']>;
  customerMessageTemplate?: InputMaybe<Scalars['String']['input']>;
  droneFlightMessageTemplate?: InputMaybe<Scalars['String']['input']>;
  orderCompleteMessageTemplate?: InputMaybe<Scalars['String']['input']>;
};

export type EditNotificationSettingOutput = {
  __typename?: 'EditNotificationSettingOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditOrderEndDateInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  orderId: Scalars['Float']['input'];
};

export type EditOrderEndDateOutput = {
  __typename?: 'EditOrderEndDateOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditOrderStatusDeliveredInput = {
  orderId: Scalars['Float']['input'];
};

export type EditOrderStatusDeliveredOutput = {
  __typename?: 'EditOrderStatusDeliveredOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditOrderStatusInput = {
  orderId: Scalars['Float']['input'];
  status: OrderStatus;
};

export type EditOrderStatusOutput = {
  __typename?: 'EditOrderStatusOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditOrderStatusStoredInput = {
  orderId: Scalars['Float']['input'];
};

export type EditOrderStatusStoredOutput = {
  __typename?: 'EditOrderStatusStoredOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditOrderStatusWithQuantityInput = {
  orderId: Scalars['Float']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
  status: OrderStatus;
};

export type EditOrderStatusWithQuantityOutput = {
  __typename?: 'EditOrderStatusWithQuantityOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditOrdersStatusInput = {
  orderIds: Array<Scalars['Float']['input']>;
  status: OrderStatus;
};

export type EditOrdersStatusOutput = {
  __typename?: 'EditOrdersStatusOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditOrdersStatusWithQuantityInput = {
  orderIds: Array<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  status: OrderStatus;
};

export type EditOrdersStatusWithQuantityOutput = {
  __typename?: 'EditOrdersStatusWithQuantityOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditPortInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  deliveryRegion?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  pickUp?: InputMaybe<Scalars['Boolean']['input']>;
  portId: Scalars['Float']['input'];
  projectId?: InputMaybe<Scalars['Float']['input']>;
  regionKeyWord?: InputMaybe<Array<Scalars['String']['input']>>;
  serviceId?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<PortStatus>;
  usageTime?: InputMaybe<Scalars['String']['input']>;
};

export type EditPortOutput = {
  __typename?: 'EditPortOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditProjectInput = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  note: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['Float']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ProjectStatus>;
};

export type EditProjectOutput = {
  __typename?: 'EditProjectOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditReceiptAddressInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  receiptId: Scalars['Float']['input'];
};

export type EditReceiptAddressOutput = {
  __typename?: 'EditReceiptAddressOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditStaffUserInput = {
  linkServiceIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
  userId: Scalars['Float']['input'];
  workerType?: InputMaybe<WorkerType>;
};

export type EditStaffUserOutput = {
  __typename?: 'EditStaffUserOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EditgoodReviewOutput = {
  __typename?: 'EditgoodReviewOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EndLoadPocketInput = {
  pocketId: Scalars['Float']['input'];
};

export type EndLoadPocketOutput = {
  __typename?: 'EndLoadPocketOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type EndSavePocketInput = {
  pocketId: Scalars['Float']['input'];
};

export type EndSavePocketOutput = {
  __typename?: 'EndSavePocketOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export enum ExchangeStatus {
  Complete = 'Complete',
  Pending = 'Pending',
  PickUp = 'PickUp',
  ReDelivery = 'ReDelivery',
  Refunded = 'Refunded'
}

export type Flight = {
  __typename?: 'Flight';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  drone?: Maybe<Drone>;
  flightTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  landAt?: Maybe<Scalars['DateTime']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  orderAt?: Maybe<Scalars['DateTime']['output']>;
  pack?: Maybe<Pack>;
  pilotFrom?: Maybe<User>;
  pilotTo?: Maybe<User>;
  portFrom?: Maybe<Port>;
  portTo?: Maybe<Port>;
  project?: Maybe<Project>;
  status?: Maybe<FlightStatus>;
  takeOffAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export enum FlightStatus {
  Cancel = 'Cancel',
  Land = 'Land',
  Ready = 'Ready',
  Stop = 'Stop',
  TakeOff = 'TakeOff'
}

export type GetAddressInput = {
  id: Scalars['Float']['input'];
};

export type GetAddressOutput = {
  __typename?: 'GetAddressOutput';
  address?: Maybe<Address>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type GetBannerInput = {
  bannerId: Scalars['Float']['input'];
};

export type GetBannerMainActiveInput = {
  serviceName: Scalars['String']['input'];
};

export type GetBannerMainActiveOutput = {
  __typename?: 'GetBannerMainActiveOutput';
  bannerMain?: Maybe<Array<BannerMain>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type GetBannerMainEventInput = {
  eventId: Scalars['Float']['input'];
};

export type GetBannerMainInput = {
  bannerMainId: Scalars['Float']['input'];
};

export type GetBannerOptionActiveOutput = {
  __typename?: 'GetBannerOptionActiveOutput';
  bannerOption?: Maybe<Array<BannerOption>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type GetBannerOutput = {
  __typename?: 'GetBannerOutput';
  banner?: Maybe<Banner>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type GetCorporationCategoryInput = {
  corporationId: Scalars['Float']['input'];
};

export type GetCorporationCategoryOutput = {
  __typename?: 'GetCorporationCategoryOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  subCategories?: Maybe<Array<SubCategory>>;
};

export type GetCorporationInput = {
  corporationId: Scalars['Float']['input'];
  userId?: InputMaybe<Scalars['Float']['input']>;
};

export type GetCorporationOutput = {
  __typename?: 'GetCorporationOutput';
  corporation?: Maybe<Corporation>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type GetCouponInput = {
  couponId?: InputMaybe<Scalars['Float']['input']>;
};

export type GetCouponOutput = {
  __typename?: 'GetCouponOutput';
  coupon?: Maybe<Coupon>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type GetDroneInput = {
  droneId: Scalars['Float']['input'];
};

export type GetDroneOutput = {
  __typename?: 'GetDroneOutput';
  drone?: Maybe<Drone>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type GetFlightInput = {
  flightId: Scalars['Float']['input'];
};

export type GetFlightOutput = {
  __typename?: 'GetFlightOutput';
  err?: Maybe<Scalars['String']['output']>;
  flight?: Maybe<Flight>;
  ok: Scalars['Boolean']['output'];
};

export type GetGoodInput = {
  goodId: Scalars['Float']['input'];
};

export type GetGoodOutput = {
  __typename?: 'GetGoodOutput';
  err?: Maybe<Scalars['String']['output']>;
  good?: Maybe<Good>;
  ok: Scalars['Boolean']['output'];
};

export type GetGoodReviewInput = {
  reviewId?: InputMaybe<Scalars['Float']['input']>;
};

export type GetGoodReviewOutput = {
  __typename?: 'GetGoodReviewOutput';
  err?: Maybe<Scalars['String']['output']>;
  goodReview?: Maybe<GoodReview>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type GetInquiryInput = {
  inquiryId: Scalars['Float']['input'];
};

export type GetInquiryOutput = {
  __typename?: 'GetInquiryOutput';
  err?: Maybe<Scalars['String']['output']>;
  inquiry?: Maybe<Inquiry>;
  ok: Scalars['Boolean']['output'];
};

export type GetJoinUserCertInput = {
  id: Scalars['Float']['input'];
  imp_uid: Scalars['String']['input'];
};

export type GetJoinUserCertOutput = {
  __typename?: 'GetJoinUserCertOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type GetKakaoEmailInput = {
  code?: InputMaybe<Scalars['String']['input']>;
};

export type GetKakaoEmailOutput = {
  __typename?: 'GetKakaoEmailOutput';
  email?: Maybe<Scalars['String']['output']>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type GetLinkServiceInput = {
  linkServiceId: Scalars['Float']['input'];
};

export type GetLinkServiceNearInput = {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

export type GetLinkServiceNearOutput = {
  __typename?: 'GetLinkServiceNearOutput';
  err?: Maybe<Scalars['String']['output']>;
  linkservice?: Maybe<LinkService>;
  ok: Scalars['Boolean']['output'];
};

export type GetLinkServiceOutput = {
  __typename?: 'GetLinkServiceOutput';
  err?: Maybe<Scalars['String']['output']>;
  linkService?: Maybe<LinkService>;
  ok: Scalars['Boolean']['output'];
};

export type GetMainCategoryInput = {
  id: Scalars['Float']['input'];
};

export type GetMainCategoryOutput = {
  __typename?: 'GetMainCategoryOutput';
  err?: Maybe<Scalars['String']['output']>;
  mainCategory?: Maybe<MainCategory>;
  ok: Scalars['Boolean']['output'];
};

export type GetNotificationSettingOutput = {
  __typename?: 'GetNotificationSettingOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  setting?: Maybe<NotificationSetting>;
};

export type GetOrderInput = {
  orderId: Scalars['Float']['input'];
};

export type GetOrderOutput = {
  __typename?: 'GetOrderOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  order: Order;
};

export type GetPaymentDataInput = {
  imp_uid?: InputMaybe<Scalars['String']['input']>;
  receiptUuid?: InputMaybe<Scalars['String']['input']>;
};

export type GetPaymentDataOutput = {
  __typename?: 'GetPaymentDataOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  receipt?: Maybe<Receipt>;
};

export type GetPgOptionInput = {
  receiptId: Scalars['Float']['input'];
};

export type GetPgOptionOutput = {
  __typename?: 'GetPgOptionOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  pgOption?: Maybe<PgOption>;
};

export type GetPortInput = {
  portId: Scalars['Float']['input'];
};

export type GetPortOutput = {
  __typename?: 'GetPortOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  port?: Maybe<Port>;
};

export type GetProjectInput = {
  projectId?: InputMaybe<Scalars['Float']['input']>;
};

export type GetProjectOutput = {
  __typename?: 'GetProjectOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  project?: Maybe<Project>;
};

export type GetReceiptInput = {
  receiptUuid: Scalars['String']['input'];
};

export type GetReceiptOutput = {
  __typename?: 'GetReceiptOutput';
  deliveryFee?: Maybe<Scalars['Float']['output']>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  receipt?: Maybe<Receipt>;
};

export type GetUpUserCertInput = {
  imp_uid: Scalars['String']['input'];
};

export type GetUpUserCertOutput = {
  __typename?: 'GetUpUserCertOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

export type GetUserEmailInput = {
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type GetUserEmailOutput = {
  __typename?: 'GetUserEmailOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  users?: Maybe<Array<User>>;
};

export type Good = {
  __typename?: 'Good';
  attributeSet?: Maybe<Scalars['String']['output']>;
  author?: Maybe<User>;
  basketItems?: Maybe<Array<BasketItem>>;
  corporation?: Maybe<Corporation>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  discountRate?: Maybe<Scalars['Float']['output']>;
  expirydate?: Maybe<Scalars['DateTime']['output']>;
  goodAttrInfo?: Maybe<Scalars['String']['output']>;
  goodDetails?: Maybe<Array<GoodDetail>>;
  goodOptions?: Maybe<Array<GoodOption>>;
  goodOrder?: Maybe<GoodOrder>;
  goodPosters?: Maybe<Array<GoodPoster>>;
  goodRelations?: Maybe<Array<GoodRelation>>;
  goodReviews?: Maybe<Array<GoodReview>>;
  id: Scalars['Float']['output'];
  likeCount: Scalars['Float']['output'];
  limitNumOrders: Scalars['Float']['output'];
  orders?: Maybe<Array<Order>>;
  plu?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  related?: Maybe<GoodRelation>;
  status: GoodStatus;
  subCategory?: Maybe<SubCategory>;
  suggestion: Scalars['Boolean']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Tags>>;
  title: Scalars['String']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
  views: Scalars['Float']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};

export type GoodDetail = {
  __typename?: 'GoodDetail';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  detailType?: Maybe<GoodDetailType>;
  file?: Maybe<Scalars['String']['output']>;
  good?: Maybe<Good>;
  id: Scalars['Float']['output'];
  index: Scalars['Float']['output'];
  note?: Maybe<Scalars['String']['output']>;
  upload?: Maybe<Upload>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum GoodDetailType {
  ContentArea = 'ContentArea',
  Image = 'Image',
  Paragraph = 'Paragraph',
  TextArea = 'TextArea',
  Video = 'Video'
}

export type GoodOption = {
  __typename?: 'GoodOption';
  attributeSet?: Maybe<Scalars['String']['output']>;
  basketItems?: Maybe<Array<BasketItem>>;
  corporation?: Maybe<Corporation>;
  count?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateActive: Scalars['Boolean']['output'];
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  desc?: Maybe<Scalars['String']['output']>;
  discountRate?: Maybe<Scalars['Float']['output']>;
  expirydate?: Maybe<Scalars['DateTime']['output']>;
  good?: Maybe<Good>;
  goodAttrInfo?: Maybe<Scalars['String']['output']>;
  goodOptionUuid?: Maybe<Scalars['String']['output']>;
  goodOrder?: Maybe<GoodOrder>;
  id: Scalars['Float']['output'];
  index?: Maybe<Scalars['Float']['output']>;
  isActive: Scalars['Boolean']['output'];
  isEvent: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  orders?: Maybe<Array<Order>>;
  price?: Maybe<Scalars['Float']['output']>;
  relatedThisGoodOption?: Maybe<Array<GoodRelation>>;
  stock?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export enum GoodOrder {
  None = 'None',
  Order = 'Order'
}

export type GoodPoster = {
  __typename?: 'GoodPoster';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  good?: Maybe<Good>;
  id: Scalars['Float']['output'];
  index: Scalars['Float']['output'];
  isRep: Scalars['Boolean']['output'];
  upload?: Maybe<Upload>;
};

export type GoodRelation = {
  __typename?: 'GoodRelation';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  good?: Maybe<Good>;
  goodOption?: Maybe<GoodOption>;
  id: Scalars['Float']['output'];
  index?: Maybe<Scalars['Float']['output']>;
  relatedGoods?: Maybe<Array<Good>>;
};

export type GoodReview = {
  __typename?: 'GoodReview';
  author?: Maybe<User>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  good: Good;
  goodReviewPosters?: Maybe<Array<GoodReviewPoster>>;
  id: Scalars['Float']['output'];
  note: Scalars['String']['output'];
  order?: Maybe<Order>;
  rating: Scalars['Float']['output'];
};

export type GoodReviewPoster = {
  __typename?: 'GoodReviewPoster';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Float']['output'];
  index: Scalars['Float']['output'];
  review?: Maybe<GoodReview>;
  upload?: Maybe<Upload>;
};

export enum GoodStatus {
  GoodSales = 'GoodSales',
  Make = 'Make',
  Ready = 'Ready',
  Sales = 'Sales',
  SoldOut = 'SoldOut',
  Etc = 'etc',
  GoodReady = 'goodReady',
  NotSale = 'notSale'
}

export enum HowToReceive {
  Delivery = 'Delivery',
  PickUp = 'PickUp'
}

export type Inquiry = {
  __typename?: 'Inquiry';
  author: User;
  comments?: Maybe<Array<Comment>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  inquiryPosters?: Maybe<Array<InquiryPoster>>;
  manager?: Maybe<User>;
  note: Scalars['String']['output'];
  receipt?: Maybe<Receipt>;
  status: InquiryStatus;
  title: Scalars['String']['output'];
  type: InquiryType;
};

export type InquiryPoster = {
  __typename?: 'InquiryPoster';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Float']['output'];
  index: Scalars['Float']['output'];
  inquiry?: Maybe<Inquiry>;
  upload?: Maybe<Upload>;
};

export enum InquiryStatus {
  Complete = 'Complete',
  Fail = 'Fail',
  New = 'New',
  Pending = 'Pending',
  PendingRefund = 'PendingRefund',
  Refund = 'Refund',
  Reply = 'Reply'
}

export enum InquiryType {
  Goods = 'Goods',
  Question = 'Question',
  Refund = 'Refund',
  System = 'System'
}

export type LinkService = {
  __typename?: 'LinkService';
  address?: Maybe<Scalars['String']['output']>;
  bannerMains?: Maybe<Array<BannerMain>>;
  corporations?: Maybe<Corporation>;
  coupons?: Maybe<Array<Coupon>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  isManualActive: Scalars['Boolean']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  minAmount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  operationFrom?: Maybe<Scalars['String']['output']>;
  operationTo?: Maybe<Scalars['String']['output']>;
  ports?: Maybe<Array<Port>>;
  region?: Maybe<Scalars['String']['output']>;
  useDeliveryFee: Scalars['Boolean']['output'];
};

export type ListAddressOutput = {
  __typename?: 'ListAddressOutput';
  address?: Maybe<Array<Address>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ListBannerInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListBannerMainInput = {
  linkServiceId: Scalars['Float']['input'];
};

export type ListBannerMainOutput = {
  __typename?: 'ListBannerMainOutput';
  bannerMain?: Maybe<Array<BannerMain>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListBannerOptionOutput = {
  __typename?: 'ListBannerOptionOutput';
  bannerOptions?: Maybe<Array<BannerOption>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListBannerOutput = {
  __typename?: 'ListBannerOutput';
  banners?: Maybe<Array<Banner>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListBasketItemOutput = {
  __typename?: 'ListBasketItemOutput';
  basketItems?: Maybe<Array<BasketItem>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ListBasketItemServiceInput = {
  serviceId: Scalars['Float']['input'];
};

export type ListBasketItemServiceOutput = {
  __typename?: 'ListBasketItemServiceOutput';
  basketItems?: Maybe<Array<BasketItem>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ListCommentInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  inquiryId: Scalars['Float']['input'];
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListCommentOutput = {
  __typename?: 'ListCommentOutput';
  comments?: Maybe<Array<Comment>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListCorporationByLocationInput = {
  serviceId?: InputMaybe<Scalars['Float']['input']>;
};

export type ListCorporationByLocationOutput = {
  __typename?: 'ListCorporationByLocationOutput';
  corporations?: Maybe<Array<Corporation>>;
  err?: Maybe<Scalars['String']['output']>;
  mainCategories?: Maybe<Array<MainCategory>>;
  ok: Scalars['Boolean']['output'];
};

export type ListCorporationInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  serviceId?: InputMaybe<Scalars['Float']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListCorporationOutput = {
  __typename?: 'ListCorporationOutput';
  corporations?: Maybe<Array<Corporation>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListCorporationSelectOutput = {
  __typename?: 'ListCorporationSelectOutput';
  corporations?: Maybe<Array<Corporation>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ListCouponCorporationInput = {
  corporationId?: InputMaybe<Scalars['Float']['input']>;
  userId?: InputMaybe<Scalars['Float']['input']>;
};

export type ListCouponCorporationOutput = {
  __typename?: 'ListCouponCorporationOutput';
  coupons?: Maybe<Array<Coupon>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ListCouponInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListCouponLocationInput = {
  serviceId: Scalars['Float']['input'];
  userId?: InputMaybe<Scalars['Float']['input']>;
};

export type ListCouponLocationOutput = {
  __typename?: 'ListCouponLocationOutput';
  coupons?: Maybe<Array<CouponWithAvailability>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ListCouponOutput = {
  __typename?: 'ListCouponOutput';
  coupons?: Maybe<Array<Coupon>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListDriverSelectOutput = {
  __typename?: 'ListDriverSelectOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  users?: Maybe<Array<User>>;
};

export type ListDroneInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListDroneOutput = {
  __typename?: 'ListDroneOutput';
  drones?: Maybe<Array<Drone>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListDroneSelectOutput = {
  __typename?: 'ListDroneSelectOutput';
  drones?: Maybe<Array<Drone>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ListFlightInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListFlightOutput = {
  __typename?: 'ListFlightOutput';
  err?: Maybe<Scalars['String']['output']>;
  flights?: Maybe<Array<Flight>>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListGoodAllOutput = {
  __typename?: 'ListGoodAllOutput';
  err?: Maybe<Scalars['String']['output']>;
  goods?: Maybe<Array<Good>>;
  ok: Scalars['Boolean']['output'];
};

export type ListGoodDetailInput = {
  goodId: Scalars['Float']['input'];
};

export type ListGoodDetailOutput = {
  __typename?: 'ListGoodDetailOutput';
  err?: Maybe<Scalars['String']['output']>;
  goodDetails?: Maybe<Array<GoodDetail>>;
  ok: Scalars['Boolean']['output'];
};

export type ListGoodInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  serviceId?: InputMaybe<Scalars['Float']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<GoodStatus>;
  tag?: InputMaybe<Tags>;
};

export type ListGoodOptionInput = {
  goodId?: InputMaybe<Scalars['Float']['input']>;
};

export type ListGoodOptionOutput = {
  __typename?: 'ListGoodOptionOutput';
  err?: Maybe<Scalars['String']['output']>;
  goodOptions?: Maybe<Array<GoodOption>>;
  ok: Scalars['Boolean']['output'];
};

export type ListGoodOutput = {
  __typename?: 'ListGoodOutput';
  err?: Maybe<Scalars['String']['output']>;
  goods?: Maybe<Array<Good>>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListGoodPosterInput = {
  goodId: Scalars['Float']['input'];
};

export type ListGoodPosterOutput = {
  __typename?: 'ListGoodPosterOutput';
  err?: Maybe<Scalars['String']['output']>;
  goodPosters?: Maybe<Array<GoodPoster>>;
  ok: Scalars['Boolean']['output'];
};

export type ListGoodRelationInput = {
  goodId: Scalars['Float']['input'];
};

export type ListGoodRelationOutput = {
  __typename?: 'ListGoodRelationOutput';
  err?: Maybe<Scalars['String']['output']>;
  goodRelations?: Maybe<Array<GoodRelation>>;
  ok: Scalars['Boolean']['output'];
};

export type ListGoodReviewInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  goodId?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListGoodReviewOutput = {
  __typename?: 'ListGoodReviewOutput';
  err?: Maybe<Scalars['String']['output']>;
  goodReviews?: Maybe<Array<GoodReview>>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListGoodSuggestionOutput = {
  __typename?: 'ListGoodSuggestionOutput';
  err?: Maybe<Scalars['String']['output']>;
  goods?: Maybe<Array<Good>>;
  ok: Scalars['Boolean']['output'];
};

export type ListInquiryCompleteInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<InquiryStatus>;
};

export type ListInquiryCompleteOutput = {
  __typename?: 'ListInquiryCompleteOutput';
  err?: Maybe<Scalars['String']['output']>;
  inquiries?: Maybe<Array<Inquiry>>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListInquiryInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListInquiryOutput = {
  __typename?: 'ListInquiryOutput';
  err?: Maybe<Scalars['String']['output']>;
  inquiries?: Maybe<Array<Inquiry>>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListLinkServiceInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListLinkServiceNearInput = {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

export type ListLinkServiceNearOutput = {
  __typename?: 'ListLinkServiceNearOutput';
  err?: Maybe<Scalars['String']['output']>;
  linkservice?: Maybe<Array<LinkService>>;
  ok: Scalars['Boolean']['output'];
};

export type ListLinkServiceOutput = {
  __typename?: 'ListLinkServiceOutput';
  err?: Maybe<Scalars['String']['output']>;
  linkservice?: Maybe<Array<LinkService>>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListLinkServiceSelectOutput = {
  __typename?: 'ListLinkServiceSelectOutput';
  err?: Maybe<Scalars['String']['output']>;
  linkservice?: Maybe<Array<LinkService>>;
  ok: Scalars['Boolean']['output'];
};

export type ListMainCategoryOutput = {
  __typename?: 'ListMainCategoryOutput';
  err?: Maybe<Scalars['String']['output']>;
  mainCategories?: Maybe<Array<MainCategory>>;
  ok: Scalars['Boolean']['output'];
};

export type ListMyGoodReviewInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListMyGoodReviewOutput = {
  __typename?: 'ListMyGoodReviewOutput';
  err?: Maybe<Scalars['String']['output']>;
  goodReviews?: Maybe<Array<GoodReview>>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListOrderInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  serviceId?: InputMaybe<Scalars['Float']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<OrderStatus>>;
};

export type ListOrderKioskDroneOutput = {
  __typename?: 'ListOrderKioskDroneOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  orders?: Maybe<Array<Order>>;
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListOrderKioskInput = {
  phone?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ListOrderKioskMeOutput = {
  __typename?: 'ListOrderKioskMeOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  orders?: Maybe<Array<Order>>;
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListOrderKioskOutput = {
  __typename?: 'ListOrderKioskOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  orders?: Maybe<Array<Order>>;
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListOrderOutput = {
  __typename?: 'ListOrderOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  orders?: Maybe<Array<Order>>;
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListOrderReviewOutput = {
  __typename?: 'ListOrderReviewOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  orders?: Maybe<Array<Order>>;
};

export type ListPackEditInput = {
  packId: Scalars['Float']['input'];
};

export type ListPackEditOutput = {
  __typename?: 'ListPackEditOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  packs?: Maybe<Array<Pack>>;
};

export type ListPackInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListPackOrderInput = {
  packId: Scalars['Float']['input'];
};

export type ListPackOrderOutput = {
  __typename?: 'ListPackOrderOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  orders?: Maybe<Array<Order>>;
};

export type ListPackOutput = {
  __typename?: 'ListPackOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  packs?: Maybe<Array<Pack>>;
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListPackSelectOutput = {
  __typename?: 'ListPackSelectOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  packs?: Maybe<Array<Pack>>;
};

export type ListPortByLocationInput = {
  serviceId: Scalars['Float']['input'];
};

export type ListPortByLocationOutput = {
  __typename?: 'ListPortByLocationOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  ports?: Maybe<Array<Port>>;
};

export type ListPortInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListPortOutput = {
  __typename?: 'ListPortOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  ports?: Maybe<Array<Port>>;
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListPortPickUpOutput = {
  __typename?: 'ListPortPickUpOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  ports?: Maybe<Array<Port>>;
};

export type ListPortSelectOutput = {
  __typename?: 'ListPortSelectOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  ports?: Maybe<Array<Port>>;
};

export type ListProjectInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListProjectOutput = {
  __typename?: 'ListProjectOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  projects?: Maybe<Array<Project>>;
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListProjectSelectOutput = {
  __typename?: 'ListProjectSelectOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  projects?: Maybe<Array<Project>>;
};

export type ListReceiptInput = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ReceiptStatus>;
};

export type ListReceiptOutput = {
  __typename?: 'ListReceiptOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  receipts?: Maybe<Array<Receipt>>;
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListReceiptReviewInput = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ReceiptStatus>;
};

export type ListReceiptReviewOutput = {
  __typename?: 'ListReceiptReviewOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  receipts?: Maybe<Array<Receipt>>;
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
};

export type ListRelatedGoodInput = {
  goodId: Scalars['Float']['input'];
};

export type ListRelatedGoodOutput = {
  __typename?: 'ListRelatedGoodOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  relatedGoods?: Maybe<Array<Good>>;
};

export type ListStaffUserInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  row?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListStaffUserOutput = {
  __typename?: 'ListStaffUserOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  row?: Maybe<Scalars['Float']['output']>;
  totalPages?: Maybe<Scalars['Float']['output']>;
  totalResults?: Maybe<Scalars['Float']['output']>;
  users?: Maybe<Array<User>>;
};

export type ListSubCategoryInput = {
  corporationId?: InputMaybe<Scalars['Float']['input']>;
};

export type ListSubCategoryOutput = {
  __typename?: 'ListSubCategoryOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  subCategories?: Maybe<Array<SubCategory>>;
};

export type ListUserCouponInput = {
  corporationId?: InputMaybe<Scalars['Float']['input']>;
  serviceId?: InputMaybe<Scalars['Float']['input']>;
  userId?: InputMaybe<Scalars['Float']['input']>;
};

export type ListUserCouponOutput = {
  __typename?: 'ListUserCouponOutput';
  coupons?: Maybe<Array<CouponWithAvailability>>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ListUserKioskInput = {
  digits: Scalars['String']['input'];
};

export type ListUserKioskOutput = {
  __typename?: 'ListUserKioskOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  users?: Maybe<Array<User>>;
};

export type ListUserSelectOutput = {
  __typename?: 'ListUserSelectOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  users?: Maybe<Array<User>>;
};

export type LoginInput = {
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type LoginKioskInput = {
  id: Scalars['Float']['input'];
  simplePassword?: InputMaybe<Scalars['String']['input']>;
};

export type LoginKioskOutput = {
  __typename?: 'LoginKioskOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type LoginOutput = {
  __typename?: 'LoginOutput';
  err?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  ok: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type MainCategory = {
  __typename?: 'MainCategory';
  corporations?: Maybe<Array<Corporation>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Float']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  upload?: Maybe<Upload>;
};

export type Mutation = {
  __typename?: 'Mutation';
  activeBanner: ActiveBannerOutput;
  activeBannerOption: ActiveBannerOptionOutput;
  cancelOrder: CancelOrderOutput;
  cancelOrders: CancelOrdersOutput;
  cancelReceipt: UpReceiptCancelOutput;
  changeActive: ChangeActiveOutput;
  changeServiceActive: ChangeServiceActiveOutput;
  confirmOrderKiosk: ConfirmOrderKioskOutput;
  crAddress: CrAddressOutput;
  crBanner: CrBannerOutput;
  crBannerMain: CrBannerMainOutput;
  crBannerOption: CrBannerOptionOutput;
  crBasketItem: CrBasketItemOutput;
  crComment: CrCommentOutput;
  crCorporation: CrCorporationOutput;
  crCoupon: CrCouponOutput;
  crDefaultPocket: CrDefaultPocketOutput;
  crDrone: CrDroneOutput;
  crFlight: CrFlightOutput;
  crGood: CrGoodOutput;
  crGoodBulk: CrGoodBulkOutput;
  crGoodDetail: CrGoodDetailOutput;
  crGoodOption: CrGoodOptionOutput;
  crGoodPoster: CrGoodPosterOutput;
  crGoodReview: CrgoodReviewOutput;
  crGoodReviewPoster: CrGoodReviewPosterOutput;
  crInquiry: CrInquiryOutput;
  crInquiryPoster: CrInquiryPosterOutput;
  crLinkService: CrLinkServiceOutput;
  crMainCategory: CrMainCategoryOutput;
  crPack: CrPackOutput;
  crPort: CrPortOutput;
  crProject: CrProjectOutput;
  crReceipt: CrReceiptOutput;
  crSnsUser: CrSnsUserOutput;
  crStaffUser: CrStaffUserOutput;
  crUser: CrUserOutput;
  crUserCoupon: CrUserCouponOutput;
  delAddress: DelAddressOutput;
  delBanner: DelBannerOutput;
  delBannerMain: DelBannerMainOutput;
  delBasketItem: DelBasketItemOutput;
  delComment: DelCommentOutput;
  delCorporation: DelCorporationOutput;
  delCoupon: DelCouponOutput;
  delDrone: DelDroneOutput;
  delFlight: DelFlightOutput;
  delGood: DelGoodOutput;
  delGoodDetail: DelGoodDetailOutput;
  delGoodOption: DelGoodOptionOutput;
  delGoodPoster: DelGoodPosterOutput;
  delGoodReview: DelGoodReviewOutput;
  delGoodReviewPoster: DelGoodReviewPosterOutput;
  delInquiry: DelInquiryOutput;
  delInquiryPoster: DelInquiryPosterOutput;
  delLinkService: DelLinkServiceOutput;
  delMainCategory: DelMainCategoryOutput;
  delOrder: DelOrderOutput;
  delPack: DelPackOutput;
  delPackOrder: DelPackOrderOutput;
  delPort: DelPortOutput;
  delProject: DelProjectOutput;
  delUser: DelUserOutput;
  editBanner: EditBannerOutput;
  editBannerMain: EditBannerMainOutput;
  editBannerMainIndex: EditBannerMainIndexOutput;
  editBannerOption: EditBannerOptionOutput;
  editBusinessInfo: EditBusinessInfoOutput;
  editComment: EditCommentOutput;
  editCorporation: EditCorporationOutput;
  editCoupon: EditCouponOutput;
  editDrone: EditDroneOutput;
  editExchangeStatus: EditExchangeStatusOutput;
  editFlight: EditFlightOutput;
  editFlightStatus: EditFlightStatusOutput;
  editGood: EditGoodOutput;
  editGoodAttr: EditGoodAttrOutput;
  editGoodAttrInfo: EditGoodAttrInfoOutput;
  editGoodDetail: EditGoodDetailOutput;
  editGoodDetailIndex: EditGoodDetailIndexOutput;
  editGoodOption: EditGoodOptionOutput;
  editGoodOrder: EditGoodOrderOutput;
  editGoodPoster: EditGoodPosterOutput;
  editGoodReview: EditgoodReviewOutput;
  editGoodStatus: EditGoodStatusOutput;
  editGoodsStatus: EditGoodsStatusOutput;
  editInquiry: EditInquiryOutput;
  editInquiryStatus: EditInquiryStatusOutput;
  editLinkService: EditLinkServiceOutput;
  editMainCategory: EditMainCategoryOutput;
  editNotificationSetting: EditNotificationSettingOutput;
  editOrderEndDate: EditOrderEndDateOutput;
  editOrderStatus: EditOrderStatusOutput;
  editOrderStatusDelivered: EditOrderStatusDeliveredOutput;
  editOrderStatusStored: EditOrderStatusStoredOutput;
  editOrderStatusWithQuantity: EditOrderStatusWithQuantityOutput;
  editOrdersStatus: EditOrdersStatusOutput;
  editOrdersStatusDelivered: EditOrdersStatusOutput;
  editOrdersStatusRelease: EditOrdersStatusOutput;
  editOrdersStatusWithQuantity: EditOrdersStatusWithQuantityOutput;
  editPort: EditPortOutput;
  editProject: EditProjectOutput;
  editReceiptAddress: EditReceiptAddressOutput;
  editStaffUser: EditStaffUserOutput;
  endLoadPocket: EndLoadPocketOutput;
  endSavePocket: EndSavePocketOutput;
  getAddress: GetAddressOutput;
  getJoinUserCertData: GetJoinUserCertOutput;
  getPaymentData: GetPaymentDataOutput;
  getUpUserCertData: GetUpUserCertOutput;
  getUserEmail: GetUserEmailOutput;
  login: LoginOutput;
  loginKiosk: LoginKioskOutput;
  payReceipt: PayReceiptOutput;
  sendChangePasswordEmail: SendChangePasswordEmailOutput;
  setFlightCancel: SetFlightCancelOutput;
  setFlightLand: SetFlightLandOutput;
  setFlightReady: SetFlightReadyOutput;
  setFlightStop: SetFlightStopOutput;
  setFlightTakeOff: SetFlightTakeOffOutput;
  setInquiryComplete: SetInquiryCompleteOutput;
  setInquiryPending: SetInquiryPendingOutput;
  setInquiryPendingRefund: SetInquiryPendingRefundOutput;
  setInquiryRefund: SetInquiryRefundOutput;
  setIsRead: CoreOutput;
  setOrderManager: SetOrderManagerOutput;
  setReceiptDelivered: SetReceiptDeliveredOutput;
  setReceiptHandOut: SetReceiptHandOutOutput;
  setReceiptPending: SetReceiptPendingOutput;
  snsLogin: SnsLoginOutput;
  startLoadPocket: StartLoadPocketOutput;
  startSavePocket: StartSavePocketOutput;
  upAddress: UpAddressOutput;
  upBasketItem: UpBasketItemOutput;
  upGoodDetailURL: UpGoodDetailUrlOutput;
  upReceiptAddress: UpReceiptAddressOutput;
  upUser: UpUserOutput;
  upUserPassword: UpUserPasswordOutput;
};


export type MutationActiveBannerArgs = {
  input: ActiveBannerInput;
};


export type MutationActiveBannerOptionArgs = {
  input: ActiveBannerOptionInput;
};


export type MutationCancelOrderArgs = {
  input: CancelOrderInput;
};


export type MutationCancelOrdersArgs = {
  input: CancelOrdersInput;
};


export type MutationCancelReceiptArgs = {
  input: UpReceiptCancelInput;
};


export type MutationChangeActiveArgs = {
  input: ChangeActiveInput;
};


export type MutationChangeServiceActiveArgs = {
  input: ChangeServiceActiveInput;
};


export type MutationConfirmOrderKioskArgs = {
  input: ConfirmOrderKioskInput;
};


export type MutationCrAddressArgs = {
  input: CrAddressInput;
};


export type MutationCrBannerArgs = {
  input: CrBannerInput;
};


export type MutationCrBannerMainArgs = {
  input: CrBannerMainInput;
};


export type MutationCrBasketItemArgs = {
  input: CrBasketItemInput;
};


export type MutationCrCommentArgs = {
  input: CrCommentInput;
};


export type MutationCrCorporationArgs = {
  input: CrCorporationInput;
};


export type MutationCrCouponArgs = {
  input: CrCouponInput;
};


export type MutationCrDefaultPocketArgs = {
  input: CrDefaultPocketInput;
};


export type MutationCrDroneArgs = {
  input: CrDroneInput;
};


export type MutationCrFlightArgs = {
  input: CrFlightInput;
};


export type MutationCrGoodArgs = {
  input: CrGoodInput;
};


export type MutationCrGoodBulkArgs = {
  input: CrGoodBulkInput;
};


export type MutationCrGoodDetailArgs = {
  input: CrGoodDetailInput;
};


export type MutationCrGoodOptionArgs = {
  input: CrGoodOptionInput;
};


export type MutationCrGoodPosterArgs = {
  input: CrGoodPosterInput;
};


export type MutationCrGoodReviewArgs = {
  input: CrGoodReviewInput;
};


export type MutationCrGoodReviewPosterArgs = {
  input: CrGoodReviewPosterInput;
};


export type MutationCrInquiryArgs = {
  input: CrInquiryInput;
};


export type MutationCrInquiryPosterArgs = {
  input: CrInquiryPosterInput;
};


export type MutationCrLinkServiceArgs = {
  input: CrLinkServiceInput;
};


export type MutationCrMainCategoryArgs = {
  input: CrMainCategoryInput;
};


export type MutationCrPackArgs = {
  input: CrPackInput;
};


export type MutationCrPortArgs = {
  input: CrPortInput;
};


export type MutationCrProjectArgs = {
  input: CrProjectInput;
};


export type MutationCrReceiptArgs = {
  input: CrReceiptInput;
};


export type MutationCrSnsUserArgs = {
  input: CrSnsUserInput;
};


export type MutationCrStaffUserArgs = {
  input: CrStaffUserInput;
};


export type MutationCrUserArgs = {
  input: CrUserInput;
};


export type MutationCrUserCouponArgs = {
  input: CrUserCouponInput;
};


export type MutationDelAddressArgs = {
  input: DelAddressInput;
};


export type MutationDelBannerArgs = {
  input: DelBannerInput;
};


export type MutationDelBannerMainArgs = {
  input: DelBannerMainInput;
};


export type MutationDelBasketItemArgs = {
  input: DelBasketItemInput;
};


export type MutationDelCommentArgs = {
  input: DelCommentInput;
};


export type MutationDelCorporationArgs = {
  input: DelCorporationInput;
};


export type MutationDelCouponArgs = {
  input: DelCouponInput;
};


export type MutationDelDroneArgs = {
  input: DelDroneInput;
};


export type MutationDelFlightArgs = {
  input: DelFlightInput;
};


export type MutationDelGoodArgs = {
  input: DelGoodInput;
};


export type MutationDelGoodDetailArgs = {
  input: DelGoodDetailInput;
};


export type MutationDelGoodOptionArgs = {
  input: DelGoodOptionInput;
};


export type MutationDelGoodPosterArgs = {
  input: DelGoodPosterInput;
};


export type MutationDelGoodReviewArgs = {
  input: DelGoodReviewInput;
};


export type MutationDelGoodReviewPosterArgs = {
  input: DelGoodReviewPosterInput;
};


export type MutationDelInquiryArgs = {
  input: DelInquiryInput;
};


export type MutationDelInquiryPosterArgs = {
  input: DelInquiryPosterInput;
};


export type MutationDelLinkServiceArgs = {
  input: DelLinkServiceInput;
};


export type MutationDelMainCategoryArgs = {
  input: DelMainCategoryInput;
};


export type MutationDelOrderArgs = {
  input: DelOrderInput;
};


export type MutationDelPackArgs = {
  input: DelPackInput;
};


export type MutationDelPackOrderArgs = {
  input: DelPackOrderInput;
};


export type MutationDelPortArgs = {
  input: DelPortInput;
};


export type MutationDelProjectArgs = {
  input: DelProjectInput;
};


export type MutationDelUserArgs = {
  input: DelUserInput;
};


export type MutationEditBannerArgs = {
  input: EditBannerInput;
};


export type MutationEditBannerMainArgs = {
  input: EditBannerMainInput;
};


export type MutationEditBannerMainIndexArgs = {
  input: EditBannerMainIndexInput;
};


export type MutationEditBannerOptionArgs = {
  input: EditBannerOptionInput;
};


export type MutationEditBusinessInfoArgs = {
  input: EditBusinessInfoInput;
};


export type MutationEditCommentArgs = {
  input: EditCommentInput;
};


export type MutationEditCorporationArgs = {
  input: EditCorporationInput;
};


export type MutationEditCouponArgs = {
  input: EditCouponInput;
};


export type MutationEditDroneArgs = {
  input: EditDroneInput;
};


export type MutationEditExchangeStatusArgs = {
  input: EditExchangeStatusInput;
};


export type MutationEditFlightArgs = {
  input: EditFlightInput;
};


export type MutationEditFlightStatusArgs = {
  input: EditFlightStatusInput;
};


export type MutationEditGoodArgs = {
  input: EditGoodInput;
};


export type MutationEditGoodAttrArgs = {
  input: EditGoodAttrInput;
};


export type MutationEditGoodAttrInfoArgs = {
  input: EditGoodAttrInfoInput;
};


export type MutationEditGoodDetailArgs = {
  input: EditGoodDetailInput;
};


export type MutationEditGoodDetailIndexArgs = {
  input: EditGoodDetailIndexInput;
};


export type MutationEditGoodOptionArgs = {
  input: EditGoodOptionInput;
};


export type MutationEditGoodOrderArgs = {
  input: EditGoodOrderInput;
};


export type MutationEditGoodPosterArgs = {
  input: EditGoodPosterInput;
};


export type MutationEditGoodReviewArgs = {
  input: EditGoodReviewInput;
};


export type MutationEditGoodStatusArgs = {
  input: EditGoodStatusInput;
};


export type MutationEditGoodsStatusArgs = {
  input: EditGoodsStatusInput;
};


export type MutationEditInquiryArgs = {
  input: EditInquiryInput;
};


export type MutationEditInquiryStatusArgs = {
  input: EditInquiryStatusInput;
};


export type MutationEditLinkServiceArgs = {
  input: EditLinkServiceInput;
};


export type MutationEditMainCategoryArgs = {
  input: EditMainCategoryInput;
};


export type MutationEditNotificationSettingArgs = {
  input: EditNotificationSettingInput;
};


export type MutationEditOrderEndDateArgs = {
  input: EditOrderEndDateInput;
};


export type MutationEditOrderStatusArgs = {
  input: EditOrderStatusInput;
};


export type MutationEditOrderStatusDeliveredArgs = {
  input: EditOrderStatusDeliveredInput;
};


export type MutationEditOrderStatusStoredArgs = {
  input: EditOrderStatusStoredInput;
};


export type MutationEditOrderStatusWithQuantityArgs = {
  input: EditOrderStatusWithQuantityInput;
};


export type MutationEditOrdersStatusArgs = {
  input: EditOrdersStatusInput;
};


export type MutationEditOrdersStatusDeliveredArgs = {
  input: EditOrdersStatusInput;
};


export type MutationEditOrdersStatusReleaseArgs = {
  input: EditOrdersStatusInput;
};


export type MutationEditOrdersStatusWithQuantityArgs = {
  input: EditOrdersStatusWithQuantityInput;
};


export type MutationEditPortArgs = {
  input: EditPortInput;
};


export type MutationEditProjectArgs = {
  input: EditProjectInput;
};


export type MutationEditReceiptAddressArgs = {
  input: EditReceiptAddressInput;
};


export type MutationEditStaffUserArgs = {
  input: EditStaffUserInput;
};


export type MutationEndLoadPocketArgs = {
  input: EndLoadPocketInput;
};


export type MutationEndSavePocketArgs = {
  input: EndSavePocketInput;
};


export type MutationGetAddressArgs = {
  input: GetAddressInput;
};


export type MutationGetJoinUserCertDataArgs = {
  input: GetJoinUserCertInput;
};


export type MutationGetPaymentDataArgs = {
  input: GetPaymentDataInput;
};


export type MutationGetUpUserCertDataArgs = {
  input: GetUpUserCertInput;
};


export type MutationGetUserEmailArgs = {
  input: GetUserEmailInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationLoginKioskArgs = {
  input: LoginKioskInput;
};


export type MutationPayReceiptArgs = {
  input: PayReceiptInput;
};


export type MutationSendChangePasswordEmailArgs = {
  input: SendChangePasswordEmailInput;
};


export type MutationSetFlightCancelArgs = {
  input: SetFlightCancelInput;
};


export type MutationSetFlightLandArgs = {
  input: SetFlightLandInput;
};


export type MutationSetFlightReadyArgs = {
  input: SetFlightReadyInput;
};


export type MutationSetFlightStopArgs = {
  input: SetFlightStopInput;
};


export type MutationSetFlightTakeOffArgs = {
  input: SetFlightTakeOffInput;
};


export type MutationSetInquiryCompleteArgs = {
  input: SetInquiryCompleteInput;
};


export type MutationSetInquiryPendingArgs = {
  input: SetInquiryPendingInput;
};


export type MutationSetInquiryPendingRefundArgs = {
  input: SetInquiryPendingRefundInput;
};


export type MutationSetInquiryRefundArgs = {
  input: SetInquiryRefundInput;
};


export type MutationSetIsReadArgs = {
  id: Scalars['Float']['input'];
};


export type MutationSetOrderManagerArgs = {
  input: SetOrderManagerInput;
};


export type MutationSetReceiptDeliveredArgs = {
  input: SetReceiptDeliveredInput;
};


export type MutationSetReceiptHandOutArgs = {
  input: SetReceiptHandOutInput;
};


export type MutationSetReceiptPendingArgs = {
  input: SetReceiptPendingInput;
};


export type MutationSnsLoginArgs = {
  input: SnsLoginInput;
};


export type MutationStartLoadPocketArgs = {
  input: StartLoadPocketInput;
};


export type MutationStartSavePocketArgs = {
  input: StartSavePocketInput;
};


export type MutationUpAddressArgs = {
  input: UpAddressInput;
};


export type MutationUpBasketItemArgs = {
  input: UpBasketItemInput;
};


export type MutationUpGoodDetailUrlArgs = {
  input: UpGoodDetailUrlInput;
};


export type MutationUpReceiptAddressArgs = {
  input: UpReceiptAddressInput;
};


export type MutationUpUserArgs = {
  input: UpUserInput;
};


export type MutationUpUserPasswordArgs = {
  input: UpUserPasswordInput;
};

export type NotificationSetting = {
  __typename?: 'NotificationSetting';
  adminNotifyPhone?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerMessageTemplate?: Maybe<Scalars['String']['output']>;
  droneFlightMessageTemplate?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  orderCompleteMessageTemplate?: Maybe<Scalars['String']['output']>;
};

export type Order = {
  __typename?: 'Order';
  EndDate?: Maybe<Scalars['DateTime']['output']>;
  amount: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  exchangeStatus: ExchangeStatus;
  good?: Maybe<Good>;
  goodName: Scalars['String']['output'];
  goodOption?: Maybe<GoodOption>;
  goodOptionName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  manager?: Maybe<User>;
  orderNum?: Maybe<Scalars['Float']['output']>;
  orderReceipt?: Maybe<OrderReceipt>;
  pack?: Maybe<Pack>;
  pocket?: Maybe<Pocket>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Float']['output'];
  receipt?: Maybe<Receipt>;
  redelivery?: Maybe<Redelivery>;
  review?: Maybe<GoodReview>;
  status: OrderStatus;
  userCoupons?: Maybe<Array<UserCoupon>>;
};

export type OrderReceipt = {
  __typename?: 'OrderReceipt';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  goodOption_name?: Maybe<Scalars['String']['output']>;
  good_discountRate?: Maybe<Scalars['Float']['output']>;
  good_poster_url?: Maybe<Scalars['String']['output']>;
  good_title?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  order_amount?: Maybe<Scalars['Float']['output']>;
  order_price?: Maybe<Scalars['Float']['output']>;
  order_quantity: Scalars['Float']['output'];
};

export enum OrderStatus {
  Bound = 'Bound',
  Canceled = 'Canceled',
  Complete = 'Complete',
  Delivered = 'Delivered',
  Drone = 'Drone',
  Exchange = 'Exchange',
  HandOut = 'HandOut',
  Inspect = 'Inspect',
  Pending = 'Pending',
  PendingDelivered = 'PendingDelivered',
  PendingRefund = 'PendingRefund',
  Port = 'Port',
  Refunded = 'Refunded',
  Stored = 'Stored'
}

export type Pack = {
  __typename?: 'Pack';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Float']['output'];
  orders?: Maybe<Array<Order>>;
  status?: Maybe<PackStatus>;
};

export enum PackStatus {
  Land = 'Land',
  Pending = 'Pending',
  TakeOff = 'TakeOff'
}

export type PayReceiptInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  deliveryFee?: InputMaybe<Scalars['Float']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  paid_amount?: InputMaybe<Scalars['Float']['input']>;
  paid_at?: InputMaybe<Scalars['String']['input']>;
  pass?: InputMaybe<Scalars['String']['input']>;
  pgOption?: InputMaybe<PgOptionInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receiptUuid: Scalars['String']['input'];
  receiver?: InputMaybe<Scalars['String']['input']>;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userCouponId?: InputMaybe<Scalars['Float']['input']>;
};

export type PayReceiptOutput = {
  __typename?: 'PayReceiptOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  receipt?: Maybe<Receipt>;
};

export type PgOption = {
  __typename?: 'PgOption';
  apply_num: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Float']['output'];
  imp_uid: Scalars['String']['output'];
  merchant_uid: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pay_method: Scalars['String']['output'];
  pg_tid: Scalars['String']['output'];
  pg_type: Scalars['String']['output'];
  receipt?: Maybe<Receipt>;
  receipt_url?: Maybe<Scalars['String']['output']>;
};

export type PgOptionInput = {
  apply_num: Scalars['String']['input'];
  imp_uid: Scalars['String']['input'];
  merchant_uid: Scalars['String']['input'];
  name: Scalars['String']['input'];
  pay_method: Scalars['String']['input'];
  pg_tid: Scalars['String']['input'];
  pg_type: Scalars['String']['input'];
  receipt_url?: InputMaybe<Scalars['String']['input']>;
};

export type Pocket = {
  __typename?: 'Pocket';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  direction: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  index: Scalars['Float']['output'];
  order?: Maybe<Order>;
  port: Port;
  status: PocketStatus;
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export enum PocketStatus {
  Empty = 'Empty',
  Full = 'Full',
  Repair = 'Repair',
  Running = 'Running'
}

export type Port = {
  __typename?: 'Port';
  address?: Maybe<Scalars['String']['output']>;
  addresses?: Maybe<Array<Address>>;
  author?: Maybe<User>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deliveryRegion: Scalars['Boolean']['output'];
  flightFroms?: Maybe<Array<Flight>>;
  flightTos?: Maybe<Array<Flight>>;
  id: Scalars['Float']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  linkService?: Maybe<LinkService>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  pickUp: Scalars['Boolean']['output'];
  pockets?: Maybe<Array<Pocket>>;
  project?: Maybe<Project>;
  receipts?: Maybe<Array<Receipt>>;
  regionKeyWord?: Maybe<Array<Scalars['String']['output']>>;
  status: PortStatus;
  usageTime?: Maybe<Scalars['String']['output']>;
};

export enum PortStatus {
  Operating = 'Operating',
  Pending = 'Pending',
  Repair = 'Repair'
}

export type Project = {
  __typename?: 'Project';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  flights?: Maybe<Array<Flight>>;
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  note: Scalars['String']['output'];
  ports?: Maybe<Array<Port>>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<ProjectStatus>;
};

export enum ProjectStatus {
  Completed = 'Completed',
  On = 'On',
  Pending = 'Pending'
}

export type Query = {
  __typename?: 'Query';
  changeGood: ChangeOutput;
  changeOrder: ChangeOrderOutput;
  chkAddressArea: ChkAddressAreaOutput;
  getBanner: GetBannerOutput;
  getBannerMain: GetBannerMainOutput;
  getBannerMainActive: GetBannerMainActiveOutput;
  getBannerMainEvent: GetBannerMainEventOutput;
  getBannerOptionActive: GetBannerOptionActiveOutput;
  getCorporation: GetCorporationOutput;
  getCorporationCategory: GetCorporationCategoryOutput;
  getCoupon: GetCouponOutput;
  getDrone: GetDroneOutput;
  getFlight: GetFlightOutput;
  getGood: GetGoodOutput;
  getGoodReview: GetGoodReviewOutput;
  getInquiry: GetInquiryOutput;
  getKakaoEmail: GetKakaoEmailOutput;
  getLinkService: GetLinkServiceOutput;
  getLinkServiceNear: GetLinkServiceNearOutput;
  getMainCategory: GetMainCategoryOutput;
  getNotificationSetting: GetNotificationSettingOutput;
  getOrder: GetOrderOutput;
  getPgOption: GetPgOptionOutput;
  getPort: GetPortOutput;
  getProject: GetProjectOutput;
  getReceipt: GetReceiptOutput;
  listAddress: ListAddressOutput;
  listBanner: ListBannerOutput;
  listBannerMain: ListBannerMainOutput;
  listBannerOption: ListBannerOptionOutput;
  listBasketItem: ListBasketItemOutput;
  listBasketItemService: ListBasketItemServiceOutput;
  listComment: ListCommentOutput;
  listCorporation: ListCorporationOutput;
  listCorporationByLocation: ListCorporationByLocationOutput;
  listCorporationSelect: ListCorporationSelectOutput;
  listCoupon: ListCouponOutput;
  listCouponCorporation: ListCouponCorporationOutput;
  listCouponLocation: ListCouponLocationOutput;
  listDriverSelect: ListDriverSelectOutput;
  listDrone: ListDroneOutput;
  listDroneSelect: ListDroneSelectOutput;
  listFlight: ListFlightOutput;
  listGood: ListGoodOutput;
  listGoodAll: ListGoodAllOutput;
  listGoodDetail: ListGoodDetailOutput;
  listGoodOption: ListGoodOptionOutput;
  listGoodPoster: ListGoodPosterOutput;
  listGoodRelation: ListGoodRelationOutput;
  listGoodReview: ListGoodReviewOutput;
  listGoodSuggestion: ListGoodSuggestionOutput;
  listInquiry: ListInquiryOutput;
  listInquiryComplete: ListInquiryCompleteOutput;
  listLinkService: ListLinkServiceOutput;
  listLinkServiceNear: ListLinkServiceNearOutput;
  listLinkServiceSelect: ListLinkServiceSelectOutput;
  listMainCategory: ListMainCategoryOutput;
  listMyGoodReview: ListMyGoodReviewOutput;
  listOrder: ListOrderOutput;
  listOrderKiosk: ListOrderKioskOutput;
  listOrderKioskDrone: ListOrderKioskDroneOutput;
  listOrderKioskMe: ListOrderKioskMeOutput;
  listOrderReview: ListOrderReviewOutput;
  listPack: ListPackOutput;
  listPackEdit: ListPackEditOutput;
  listPackOrder: ListPackOrderOutput;
  listPackSelect: ListPackSelectOutput;
  listPort: ListPortOutput;
  listPortByLocation: ListPortByLocationOutput;
  listPortPickup: ListPortPickUpOutput;
  listPortSelect: ListPortSelectOutput;
  listProject: ListProjectOutput;
  listProjectSelect: ListProjectSelectOutput;
  listReceipt: ListReceiptOutput;
  listReceiptReview: ListReceiptReviewOutput;
  listRelatedGoods: ListRelatedGoodOutput;
  listStaffUser: ListStaffUserOutput;
  listSubCategory: ListSubCategoryOutput;
  listUserCoupon: ListUserCouponOutput;
  listUserKiosk: ListUserKioskOutput;
  listUserSelect: ListUserSelectOutput;
  makeOrderReceipt: CrOrderReceiptOutput;
  me: User;
};


export type QueryChkAddressAreaArgs = {
  input: ChkAddressAreaInput;
};


export type QueryGetBannerArgs = {
  input: GetBannerInput;
};


export type QueryGetBannerMainArgs = {
  input: GetBannerMainInput;
};


export type QueryGetBannerMainActiveArgs = {
  input: GetBannerMainActiveInput;
};


export type QueryGetBannerMainEventArgs = {
  input: GetBannerMainEventInput;
};


export type QueryGetCorporationArgs = {
  input: GetCorporationInput;
};


export type QueryGetCorporationCategoryArgs = {
  input: GetCorporationCategoryInput;
};


export type QueryGetCouponArgs = {
  input: GetCouponInput;
};


export type QueryGetDroneArgs = {
  input: GetDroneInput;
};


export type QueryGetFlightArgs = {
  input: GetFlightInput;
};


export type QueryGetGoodArgs = {
  input: GetGoodInput;
};


export type QueryGetGoodReviewArgs = {
  input: GetGoodReviewInput;
};


export type QueryGetInquiryArgs = {
  input: GetInquiryInput;
};


export type QueryGetKakaoEmailArgs = {
  input: GetKakaoEmailInput;
};


export type QueryGetLinkServiceArgs = {
  input: GetLinkServiceInput;
};


export type QueryGetLinkServiceNearArgs = {
  input: GetLinkServiceNearInput;
};


export type QueryGetMainCategoryArgs = {
  input: GetMainCategoryInput;
};


export type QueryGetOrderArgs = {
  input: GetOrderInput;
};


export type QueryGetPgOptionArgs = {
  input: GetPgOptionInput;
};


export type QueryGetPortArgs = {
  input: GetPortInput;
};


export type QueryGetProjectArgs = {
  input: GetProjectInput;
};


export type QueryGetReceiptArgs = {
  input: GetReceiptInput;
};


export type QueryListBannerArgs = {
  input: ListBannerInput;
};


export type QueryListBannerMainArgs = {
  input: ListBannerMainInput;
};


export type QueryListBasketItemServiceArgs = {
  input: ListBasketItemServiceInput;
};


export type QueryListCommentArgs = {
  input: ListCommentInput;
};


export type QueryListCorporationArgs = {
  input: ListCorporationInput;
};


export type QueryListCorporationByLocationArgs = {
  input: ListCorporationByLocationInput;
};


export type QueryListCouponArgs = {
  input: ListCouponInput;
};


export type QueryListCouponCorporationArgs = {
  input: ListCouponCorporationInput;
};


export type QueryListCouponLocationArgs = {
  input: ListCouponLocationInput;
};


export type QueryListDroneArgs = {
  input: ListDroneInput;
};


export type QueryListFlightArgs = {
  input: ListFlightInput;
};


export type QueryListGoodArgs = {
  input: ListGoodInput;
};


export type QueryListGoodDetailArgs = {
  input: ListGoodDetailInput;
};


export type QueryListGoodOptionArgs = {
  input: ListGoodOptionInput;
};


export type QueryListGoodPosterArgs = {
  input: ListGoodPosterInput;
};


export type QueryListGoodRelationArgs = {
  input: ListGoodRelationInput;
};


export type QueryListGoodReviewArgs = {
  input: ListGoodReviewInput;
};


export type QueryListInquiryArgs = {
  input: ListInquiryInput;
};


export type QueryListInquiryCompleteArgs = {
  input: ListInquiryCompleteInput;
};


export type QueryListLinkServiceArgs = {
  input: ListLinkServiceInput;
};


export type QueryListLinkServiceNearArgs = {
  input: ListLinkServiceNearInput;
};


export type QueryListMyGoodReviewArgs = {
  input: ListMyGoodReviewInput;
};


export type QueryListOrderArgs = {
  input: ListOrderInput;
};


export type QueryListOrderKioskArgs = {
  input: ListOrderKioskInput;
};


export type QueryListPackArgs = {
  input: ListPackInput;
};


export type QueryListPackEditArgs = {
  input: ListPackEditInput;
};


export type QueryListPackOrderArgs = {
  input: ListPackOrderInput;
};


export type QueryListPortArgs = {
  input: ListPortInput;
};


export type QueryListPortByLocationArgs = {
  input: ListPortByLocationInput;
};


export type QueryListProjectArgs = {
  input: ListProjectInput;
};


export type QueryListReceiptArgs = {
  input: ListReceiptInput;
};


export type QueryListReceiptReviewArgs = {
  input: ListReceiptReviewInput;
};


export type QueryListRelatedGoodsArgs = {
  input: ListRelatedGoodInput;
};


export type QueryListStaffUserArgs = {
  input: ListStaffUserInput;
};


export type QueryListSubCategoryArgs = {
  input: ListSubCategoryInput;
};


export type QueryListUserCouponArgs = {
  input: ListUserCouponInput;
};


export type QueryListUserKioskArgs = {
  input: ListUserKioskInput;
};

export type Receipt = {
  __typename?: 'Receipt';
  address?: Maybe<Scalars['String']['output']>;
  basketItems?: Maybe<Array<BasketItem>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deliveryFee?: Maybe<Scalars['Float']['output']>;
  howToReceive?: Maybe<HowToReceive>;
  id: Scalars['Float']['output'];
  inquiries?: Maybe<Array<Inquiry>>;
  isBilled: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  orders?: Maybe<Array<Order>>;
  paid_amount?: Maybe<Scalars['Float']['output']>;
  paid_at?: Maybe<Scalars['String']['output']>;
  pass?: Maybe<Scalars['String']['output']>;
  pgOption?: Maybe<PgOption>;
  phone?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Port>;
  receiptNum?: Maybe<Scalars['String']['output']>;
  receiptStatus: ReceiptStatus;
  receiver?: Maybe<Scalars['String']['output']>;
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  user?: Maybe<User>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export enum ReceiptStatus {
  Canceled = 'Canceled',
  Delivered = 'Delivered',
  HandOut = 'HandOut',
  Pending = 'Pending',
  Refund = 'Refund',
  Uncharged = 'Uncharged'
}

export enum Redelivery {
  None = 'None',
  Redelivery = 'Redelivery'
}

export enum Sns {
  Google = 'Google',
  Kakao = 'Kakao',
  Nilivery = 'Nilivery'
}

export type SendChangePasswordEmailInput = {
  username?: InputMaybe<Scalars['String']['input']>;
};

export type SendChangePasswordEmailOutput = {
  __typename?: 'SendChangePasswordEmailOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SetFlightCancelInput = {
  flightId: Scalars['Float']['input'];
};

export type SetFlightCancelOutput = {
  __typename?: 'SetFlightCancelOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SetFlightLandInput = {
  flightId: Scalars['Float']['input'];
};

export type SetFlightLandOutput = {
  __typename?: 'SetFlightLandOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SetFlightReadyInput = {
  flightId: Scalars['Float']['input'];
};

export type SetFlightReadyOutput = {
  __typename?: 'SetFlightReadyOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SetFlightStopInput = {
  flightId: Scalars['Float']['input'];
};

export type SetFlightStopOutput = {
  __typename?: 'SetFlightStopOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SetFlightTakeOffInput = {
  flightId: Scalars['Float']['input'];
};

export type SetFlightTakeOffOutput = {
  __typename?: 'SetFlightTakeOffOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SetInquiryCompleteInput = {
  inquiryId: Scalars['Float']['input'];
};

export type SetInquiryCompleteOutput = {
  __typename?: 'SetInquiryCompleteOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SetInquiryPendingInput = {
  inquiryId: Scalars['Float']['input'];
};

export type SetInquiryPendingOutput = {
  __typename?: 'SetInquiryPendingOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SetInquiryPendingRefundInput = {
  inquiryId: Scalars['Float']['input'];
};

export type SetInquiryPendingRefundOutput = {
  __typename?: 'SetInquiryPendingRefundOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SetInquiryRefundInput = {
  inquiryId: Scalars['Float']['input'];
};

export type SetInquiryRefundOutput = {
  __typename?: 'SetInquiryRefundOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SetOrderManagerInput = {
  orderId: Scalars['Float']['input'];
  userId: Scalars['Float']['input'];
};

export type SetOrderManagerOutput = {
  __typename?: 'SetOrderManagerOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SetReceiptDeliveredInput = {
  receiptId: Scalars['Float']['input'];
};

export type SetReceiptDeliveredOutput = {
  __typename?: 'SetReceiptDeliveredOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SetReceiptHandOutInput = {
  receiptId: Scalars['Float']['input'];
};

export type SetReceiptHandOutOutput = {
  __typename?: 'SetReceiptHandOutOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SetReceiptPendingInput = {
  receiptId: Scalars['Float']['input'];
};

export type SetReceiptPendingOutput = {
  __typename?: 'SetReceiptPendingOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SnsLoginInput = {
  sns?: InputMaybe<Sns>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type SnsLoginOutput = {
  __typename?: 'SnsLoginOutput';
  err?: Maybe<Scalars['String']['output']>;
  exist?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  ok: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type StartLoadPocketInput = {
  orderId: Scalars['Float']['input'];
};

export type StartLoadPocketOutput = {
  __typename?: 'StartLoadPocketOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  pocket?: Maybe<Pocket>;
};

export type StartSavePocketInput = {
  orderId: Scalars['Float']['input'];
  portId: Scalars['Float']['input'];
};

export type StartSavePocketOutput = {
  __typename?: 'StartSavePocketOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  pocket?: Maybe<Pocket>;
};

export type SubCategory = {
  __typename?: 'SubCategory';
  corporation?: Maybe<Corporation>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  goods?: Maybe<Array<Good>>;
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  newOrderList: Array<Order>;
  orderStatusChanged: Scalars['Boolean']['output'];
  pendingStartSavePocket: Pocket;
};

export enum Tags {
  Accessories = 'Accessories',
  Cafe = 'Cafe',
  Camping = 'Camping',
  Chicken = 'Chicken',
  DeliveryDate = 'DeliveryDate',
  Dessert = 'Dessert',
  EcoFriendly = 'EcoFriendly',
  Emart = 'Emart',
  EventProduct = 'EventProduct',
  EventTag = 'EventTag',
  GroupPurchase = 'GroupPurchase',
  LocalFood = 'LocalFood',
  Meal = 'Meal',
  Mealkit = 'Mealkit',
  NationalFood = 'NationalFood',
  NiliGroupPurchase = 'NiliGroupPurchase',
  OutdoorGear = 'OutdoorGear',
  Popularity = 'Popularity',
  Safety = 'Safety',
  Subsidiary = 'Subsidiary',
  Suggestion = 'Suggestion',
  TodayMeal = 'TodayMeal'
}

export type UpAddressInput = {
  isRep?: InputMaybe<Scalars['Boolean']['input']>;
  mainAddress?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pass?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  subAddress?: InputMaybe<Scalars['String']['input']>;
  upAddressId?: InputMaybe<Scalars['Float']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  zoneCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpAddressOutput = {
  __typename?: 'UpAddressOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type UpBasketItemInput = {
  basketItemId: Scalars['Float']['input'];
  quantity: Scalars['Float']['input'];
};

export type UpBasketItemOutput = {
  __typename?: 'UpBasketItemOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type UpGoodDetailUrlInput = {
  id: Scalars['Float']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpGoodDetailUrlOutput = {
  __typename?: 'UpGoodDetailURLOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type UpReceiptAddressInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  howToReceive?: InputMaybe<HowToReceive>;
  message?: InputMaybe<Scalars['String']['input']>;
  pass?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  portId?: InputMaybe<Scalars['Float']['input']>;
  receiptUuid: Scalars['String']['input'];
  receiver?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};

export type UpReceiptAddressOutput = {
  __typename?: 'UpReceiptAddressOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  receipt?: Maybe<Receipt>;
};

export type UpReceiptCancelInput = {
  id: Scalars['Float']['input'];
};

export type UpReceiptCancelOutput = {
  __typename?: 'UpReceiptCancelOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type UpUserInput = {
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type UpUserOutput = {
  __typename?: 'UpUserOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type UpUserPasswordInput = {
  newPassword: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpUserPasswordOutput = {
  __typename?: 'UpUserPasswordOutput';
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type Upload = {
  __typename?: 'Upload';
  bannerMain?: Maybe<BannerMain>;
  bannerOptions?: Maybe<BannerOption>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  event?: Maybe<BannerMainEvent>;
  filename: Scalars['String']['output'];
  goodDetail?: Maybe<GoodDetail>;
  goodPoster?: Maybe<GoodPoster>;
  goodReviewPoster?: Maybe<GoodReviewPoster>;
  id: Scalars['Float']['output'];
  inquiryPoster?: Maybe<InquiryPoster>;
  isUsing: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  mainCategory?: Maybe<MainCategory>;
  mimetype: Scalars['String']['output'];
  uploader: User;
  url?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type User = {
  __typename?: 'User';
  addresses?: Maybe<Array<Address>>;
  basketItems?: Maybe<Array<BasketItem>>;
  certification?: Maybe<Scalars['Boolean']['output']>;
  comments?: Maybe<Array<Comment>>;
  corporations?: Maybe<Array<Corporation>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  drones?: Maybe<Array<Drone>>;
  files?: Maybe<Array<Upload>>;
  flightFroms?: Maybe<Array<Flight>>;
  flightTos?: Maybe<Array<Flight>>;
  flights?: Maybe<Array<Flight>>;
  goods?: Maybe<Array<Good>>;
  id: Scalars['Float']['output'];
  inquiries?: Maybe<Array<Inquiry>>;
  isRead?: Maybe<Scalars['Boolean']['output']>;
  linkServices?: Maybe<Array<LinkService>>;
  managerInquiries?: Maybe<Array<Inquiry>>;
  name?: Maybe<Scalars['String']['output']>;
  orders?: Maybe<Array<Order>>;
  password?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pushId?: Maybe<Scalars['String']['output']>;
  receipts?: Maybe<Array<Receipt>>;
  reviews?: Maybe<Array<GoodReview>>;
  role: UserRole;
  simplePassword?: Maybe<Scalars['String']['output']>;
  sns?: Maybe<Sns>;
  type?: Maybe<UserType>;
  userCoupons?: Maybe<Array<UserCoupon>>;
  username?: Maybe<Scalars['String']['output']>;
  workerType?: Maybe<WorkerType>;
};

export type UserCoupon = {
  __typename?: 'UserCoupon';
  coupon: Coupon;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Float']['output'];
  status: UserCouponStatus;
  usedAt?: Maybe<Scalars['DateTime']['output']>;
  usedInOrder?: Maybe<Order>;
  user: User;
};

export enum UserCouponStatus {
  Available = 'AVAILABLE',
  Expired = 'EXPIRED',
  Used = 'USED'
}

export enum UserRole {
  Admin = 'Admin',
  General = 'General',
  Worker = 'Worker'
}

export enum UserType {
  Test = 'Test'
}

export enum WorkerType {
  Driver = 'Driver',
  Packer = 'Packer',
  Pilot = 'Pilot'
}

export type GetBannerMainEventOutput = {
  __typename?: 'getBannerMainEventOutput';
  bannerMainEvent?: Maybe<BannerMainEvent>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type GetBannerMainOutput = {
  __typename?: 'getBannerMainOutput';
  bannerMain?: Maybe<BannerMain>;
  err?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type NewOrderListSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NewOrderListSubscription = { __typename?: 'Subscription', newOrderList: Array<{ __typename?: 'Order', id: number, createdAt?: any | null, goodName: string, goodOptionName?: string | null, quantity: number, amount: number, status: OrderStatus, manager?: { __typename?: 'User', id: number, name?: string | null } | null, receipt?: { __typename?: 'Receipt', id: number, uuid?: string | null, receiver?: string | null, address?: string | null, paid_amount?: number | null, message?: string | null, phone?: string | null, receiptStatus: ReceiptStatus, user?: { __typename?: 'User', username?: string | null, name?: string | null } | null } | null, goodOption?: { __typename?: 'GoodOption', id: number, name?: string | null, good?: { __typename?: 'Good', title: string, uuid?: string | null } | null } | null, pack?: { __typename?: 'Pack', id: number, status?: PackStatus | null } | null }> };

export type OrderStatusChangedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OrderStatusChangedSubscription = { __typename?: 'Subscription', orderStatusChanged: boolean };

export type ActiveBannerMutationVariables = Exact<{
  input: ActiveBannerInput;
}>;


export type ActiveBannerMutation = { __typename?: 'Mutation', activeBanner: { __typename?: 'ActiveBannerOutput', ok: boolean, err?: string | null } };

export type ActiveBannerOptionMutationVariables = Exact<{
  input: ActiveBannerOptionInput;
}>;


export type ActiveBannerOptionMutation = { __typename?: 'Mutation', activeBannerOption: { __typename?: 'ActiveBannerOptionOutput', ok: boolean, err?: string | null } };

export type CancelOrderMutationVariables = Exact<{
  input: CancelOrderInput;
}>;


export type CancelOrderMutation = { __typename?: 'Mutation', cancelOrder: { __typename?: 'CancelOrderOutput', ok: boolean, err?: string | null } };

export type CancelOrdersMutationVariables = Exact<{
  input: CancelOrdersInput;
}>;


export type CancelOrdersMutation = { __typename?: 'Mutation', cancelOrders: { __typename?: 'CancelOrdersOutput', ok: boolean, err?: string | null } };

export type ChangeActiveMutationVariables = Exact<{
  input: ChangeActiveInput;
}>;


export type ChangeActiveMutation = { __typename?: 'Mutation', changeActive: { __typename?: 'ChangeActiveOutput', ok: boolean, err?: string | null } };

export type ChangeServiceActiveMutationVariables = Exact<{
  input: ChangeServiceActiveInput;
}>;


export type ChangeServiceActiveMutation = { __typename?: 'Mutation', changeServiceActive: { __typename?: 'ChangeServiceActiveOutput', ok: boolean, err?: string | null } };

export type CrBannerMutationVariables = Exact<{
  input: CrBannerInput;
}>;


export type CrBannerMutation = { __typename?: 'Mutation', crBanner: { __typename?: 'CrBannerOutput', ok: boolean, err?: string | null } };

export type CrBannerMainMutationVariables = Exact<{
  input: CrBannerMainInput;
}>;


export type CrBannerMainMutation = { __typename?: 'Mutation', crBannerMain: { __typename?: 'CrBannerMainOutput', ok: boolean, err?: string | null } };

export type CrBannerOptionMutationVariables = Exact<{ [key: string]: never; }>;


export type CrBannerOptionMutation = { __typename?: 'Mutation', crBannerOption: { __typename?: 'CrBannerOptionOutput', ok: boolean, err?: string | null } };

export type CrCommentMutationVariables = Exact<{
  input: CrCommentInput;
}>;


export type CrCommentMutation = { __typename?: 'Mutation', crComment: { __typename?: 'CrCommentOutput', ok: boolean, err?: string | null } };

export type CrCorporationMutationVariables = Exact<{
  input: CrCorporationInput;
}>;


export type CrCorporationMutation = { __typename?: 'Mutation', crCorporation: { __typename?: 'CrCorporationOutput', ok: boolean, err?: string | null, createdId: number } };

export type CrCouponMutationVariables = Exact<{
  input: CrCouponInput;
}>;


export type CrCouponMutation = { __typename?: 'Mutation', crCoupon: { __typename?: 'CrCouponOutput', ok: boolean, err?: string | null } };

export type CrDroneMutationVariables = Exact<{
  input: CrDroneInput;
}>;


export type CrDroneMutation = { __typename?: 'Mutation', crDrone: { __typename?: 'CrDroneOutput', ok: boolean, err?: string | null } };

export type CrFlightMutationVariables = Exact<{
  input: CrFlightInput;
}>;


export type CrFlightMutation = { __typename?: 'Mutation', crFlight: { __typename?: 'CrFlightOutput', ok: boolean, err?: string | null } };

export type CrGoodMutationVariables = Exact<{
  input: CrGoodInput;
}>;


export type CrGoodMutation = { __typename?: 'Mutation', crGood: { __typename?: 'CrGoodOutput', ok: boolean, err?: string | null, createdId: number } };

export type CrGoodBulkMutationVariables = Exact<{
  input: CrGoodBulkInput;
}>;


export type CrGoodBulkMutation = { __typename?: 'Mutation', crGoodBulk: { __typename?: 'CrGoodBulkOutput', ok: boolean, err?: string | null } };

export type CrGoodDetailMutationVariables = Exact<{
  input: CrGoodDetailInput;
}>;


export type CrGoodDetailMutation = { __typename?: 'Mutation', crGoodDetail: { __typename?: 'CrGoodDetailOutput', ok: boolean, err?: string | null } };

export type CrGoodOptionMutationVariables = Exact<{
  input: CrGoodOptionInput;
}>;


export type CrGoodOptionMutation = { __typename?: 'Mutation', crGoodOption: { __typename?: 'CrGoodOptionOutput', ok: boolean, err?: string | null } };

export type CrGoodPosterMutationVariables = Exact<{
  input: CrGoodPosterInput;
}>;


export type CrGoodPosterMutation = { __typename?: 'Mutation', crGoodPoster: { __typename?: 'CrGoodPosterOutput', ok: boolean, err?: string | null } };

export type CrLinkServiceMutationVariables = Exact<{
  input: CrLinkServiceInput;
}>;


export type CrLinkServiceMutation = { __typename?: 'Mutation', crLinkService: { __typename?: 'CrLinkServiceOutput', ok: boolean, err?: string | null } };

export type CrMainCategoryMutationVariables = Exact<{
  input: CrMainCategoryInput;
}>;


export type CrMainCategoryMutation = { __typename?: 'Mutation', crMainCategory: { __typename?: 'CrMainCategoryOutput', ok: boolean, err?: string | null } };

export type CrPackMutationVariables = Exact<{
  input: CrPackInput;
}>;


export type CrPackMutation = { __typename?: 'Mutation', crPack: { __typename?: 'CrPackOutput', ok: boolean, err?: string | null } };

export type CrPortMutationVariables = Exact<{
  input: CrPortInput;
}>;


export type CrPortMutation = { __typename?: 'Mutation', crPort: { __typename?: 'CrPortOutput', ok: boolean, err?: string | null } };

export type CrProjectMutationVariables = Exact<{
  input: CrProjectInput;
}>;


export type CrProjectMutation = { __typename?: 'Mutation', crProject: { __typename?: 'CrProjectOutput', ok: boolean, err?: string | null } };

export type CrStaffUserMutationVariables = Exact<{
  input: CrStaffUserInput;
}>;


export type CrStaffUserMutation = { __typename?: 'Mutation', crStaffUser: { __typename?: 'CrStaffUserOutput', ok: boolean, err?: string | null, id?: number | null } };

export type DelBannerMutationVariables = Exact<{
  input: DelBannerInput;
}>;


export type DelBannerMutation = { __typename?: 'Mutation', delBanner: { __typename?: 'DelBannerOutput', ok: boolean, err?: string | null } };

export type DelBannerMainMutationVariables = Exact<{
  input: DelBannerMainInput;
}>;


export type DelBannerMainMutation = { __typename?: 'Mutation', delBannerMain: { __typename?: 'DelBannerMainOutput', ok: boolean, err?: string | null } };

export type DelCommentMutationVariables = Exact<{
  input: DelCommentInput;
}>;


export type DelCommentMutation = { __typename?: 'Mutation', delComment: { __typename?: 'DelCommentOutput', ok: boolean, err?: string | null } };

export type DelCorporationMutationVariables = Exact<{
  input: DelCorporationInput;
}>;


export type DelCorporationMutation = { __typename?: 'Mutation', delCorporation: { __typename?: 'DelCorporationOutput', ok: boolean, err?: string | null } };

export type DelDroneMutationVariables = Exact<{
  input: DelDroneInput;
}>;


export type DelDroneMutation = { __typename?: 'Mutation', delDrone: { __typename?: 'DelDroneOutput', ok: boolean, err?: string | null } };

export type DelFlightMutationVariables = Exact<{
  input: DelFlightInput;
}>;


export type DelFlightMutation = { __typename?: 'Mutation', delFlight: { __typename?: 'DelFlightOutput', ok: boolean, err?: string | null } };

export type DelGoodMutationVariables = Exact<{
  input: DelGoodInput;
}>;


export type DelGoodMutation = { __typename?: 'Mutation', delGood: { __typename?: 'DelGoodOutput', ok: boolean, err?: string | null } };

export type DelGoodDetailMutationVariables = Exact<{
  input: DelGoodDetailInput;
}>;


export type DelGoodDetailMutation = { __typename?: 'Mutation', delGoodDetail: { __typename?: 'DelGoodDetailOutput', ok: boolean, err?: string | null } };

export type DelGoodOptionMutationVariables = Exact<{
  input: DelGoodOptionInput;
}>;


export type DelGoodOptionMutation = { __typename?: 'Mutation', delGoodOption: { __typename?: 'DelGoodOptionOutput', ok: boolean, err?: string | null } };

export type DelGoodPosterMutationVariables = Exact<{
  input: DelGoodPosterInput;
}>;


export type DelGoodPosterMutation = { __typename?: 'Mutation', delGoodPoster: { __typename?: 'DelGoodPosterOutput', ok: boolean, err?: string | null } };

export type DelInquiryMutationVariables = Exact<{
  input: DelInquiryInput;
}>;


export type DelInquiryMutation = { __typename?: 'Mutation', delInquiry: { __typename?: 'DelInquiryOutput', ok: boolean, err?: string | null } };

export type DelLinkServiceMutationVariables = Exact<{
  input: DelLinkServiceInput;
}>;


export type DelLinkServiceMutation = { __typename?: 'Mutation', delLinkService: { __typename?: 'DelLinkServiceOutput', ok: boolean, err?: string | null } };

export type DelMainCategoryMutationVariables = Exact<{
  input: DelMainCategoryInput;
}>;


export type DelMainCategoryMutation = { __typename?: 'Mutation', delMainCategory: { __typename?: 'DelMainCategoryOutput', ok: boolean, err?: string | null } };

export type DelOrderMutationVariables = Exact<{
  input: DelOrderInput;
}>;


export type DelOrderMutation = { __typename?: 'Mutation', delOrder: { __typename?: 'DelOrderOutput', ok: boolean, err?: string | null } };

export type DelPackMutationVariables = Exact<{
  input: DelPackInput;
}>;


export type DelPackMutation = { __typename?: 'Mutation', delPack: { __typename?: 'DelPackOutput', ok: boolean, err?: string | null } };

export type DelPackOrderMutationVariables = Exact<{
  input: DelPackOrderInput;
}>;


export type DelPackOrderMutation = { __typename?: 'Mutation', delPackOrder: { __typename?: 'DelPackOrderOutput', ok: boolean, err?: string | null } };

export type DelPortMutationVariables = Exact<{
  input: DelPortInput;
}>;


export type DelPortMutation = { __typename?: 'Mutation', delPort: { __typename?: 'DelPortOutput', ok: boolean, err?: string | null } };

export type DelProjectMutationVariables = Exact<{
  input: DelProjectInput;
}>;


export type DelProjectMutation = { __typename?: 'Mutation', delProject: { __typename?: 'DelProjectOutput', ok: boolean, err?: string | null } };

export type DelUserMutationVariables = Exact<{
  input: DelUserInput;
}>;


export type DelUserMutation = { __typename?: 'Mutation', delUser: { __typename?: 'DelUserOutput', ok: boolean, err?: string | null } };

export type ListDriverSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type ListDriverSelectQuery = { __typename?: 'Query', listDriverSelect: { __typename?: 'ListDriverSelectOutput', ok: boolean, err?: string | null, users?: Array<{ __typename?: 'User', name?: string | null, id: number }> | null } };

export type EditBannerMutationVariables = Exact<{
  input: EditBannerInput;
}>;


export type EditBannerMutation = { __typename?: 'Mutation', editBanner: { __typename?: 'EditBannerOutput', ok: boolean, err?: string | null } };

export type EditBannerMainMutationVariables = Exact<{
  input: EditBannerMainInput;
}>;


export type EditBannerMainMutation = { __typename?: 'Mutation', editBannerMain: { __typename?: 'EditBannerMainOutput', ok: boolean, err?: string | null } };

export type EditBannerMainIndexMutationVariables = Exact<{
  input: EditBannerMainIndexInput;
}>;


export type EditBannerMainIndexMutation = { __typename?: 'Mutation', editBannerMainIndex: { __typename?: 'EditBannerMainIndexOutput', ok: boolean, err?: string | null } };

export type EditBannerOptionMutationVariables = Exact<{
  input: EditBannerOptionInput;
}>;


export type EditBannerOptionMutation = { __typename?: 'Mutation', editBannerOption: { __typename?: 'EditBannerOptionOutput', ok: boolean, err?: string | null } };

export type EditBusinessInfoMutationVariables = Exact<{
  input: EditBusinessInfoInput;
}>;


export type EditBusinessInfoMutation = { __typename?: 'Mutation', editBusinessInfo: { __typename?: 'EditBusinessInfoOutput', ok: boolean, err?: string | null } };

export type EditCommentMutationVariables = Exact<{
  input: EditCommentInput;
}>;


export type EditCommentMutation = { __typename?: 'Mutation', editComment: { __typename?: 'EditCommentOutput', ok: boolean, err?: string | null } };

export type EditCorporationMutationVariables = Exact<{
  input: EditCorporationInput;
}>;


export type EditCorporationMutation = { __typename?: 'Mutation', editCorporation: { __typename?: 'EditCorporationOutput', ok: boolean, err?: string | null } };

export type EditDroneMutationVariables = Exact<{
  input: EditDroneInput;
}>;


export type EditDroneMutation = { __typename?: 'Mutation', editDrone: { __typename?: 'EditDroneOutput', ok: boolean, err?: string | null } };

export type EditExchangeStatusMutationVariables = Exact<{
  input: EditExchangeStatusInput;
}>;


export type EditExchangeStatusMutation = { __typename?: 'Mutation', editExchangeStatus: { __typename?: 'EditExchangeStatusOutput', ok: boolean, err?: string | null } };

export type EditFlightMutationVariables = Exact<{
  input: EditFlightInput;
}>;


export type EditFlightMutation = { __typename?: 'Mutation', editFlight: { __typename?: 'EditFlightOutput', ok: boolean, err?: string | null } };

export type EditFlightStatusMutationVariables = Exact<{
  input: EditFlightStatusInput;
}>;


export type EditFlightStatusMutation = { __typename?: 'Mutation', editFlightStatus: { __typename?: 'EditFlightStatusOutput', ok: boolean, err?: string | null } };

export type EditGoodMutationVariables = Exact<{
  input: EditGoodInput;
}>;


export type EditGoodMutation = { __typename?: 'Mutation', editGood: { __typename?: 'EditGoodOutput', ok: boolean, err?: string | null } };

export type EditGoodAttrMutationVariables = Exact<{
  input: EditGoodAttrInput;
}>;


export type EditGoodAttrMutation = { __typename?: 'Mutation', editGoodAttr: { __typename?: 'EditGoodAttrOutput', ok: boolean, err?: string | null } };

export type EditGoodAttrInfoMutationVariables = Exact<{
  input: EditGoodAttrInfoInput;
}>;


export type EditGoodAttrInfoMutation = { __typename?: 'Mutation', editGoodAttrInfo: { __typename?: 'EditGoodAttrInfoOutput', ok: boolean, err?: string | null } };

export type EditGoodDetailMutationVariables = Exact<{
  input: EditGoodDetailInput;
}>;


export type EditGoodDetailMutation = { __typename?: 'Mutation', editGoodDetail: { __typename?: 'EditGoodDetailOutput', ok: boolean, err?: string | null } };

export type EditGoodDetailIndexMutationVariables = Exact<{
  input: EditGoodDetailIndexInput;
}>;


export type EditGoodDetailIndexMutation = { __typename?: 'Mutation', editGoodDetailIndex: { __typename?: 'EditGoodDetailIndexOutput', ok: boolean, err?: string | null } };

export type EditGoodOptionMutationVariables = Exact<{
  input: EditGoodOptionInput;
}>;


export type EditGoodOptionMutation = { __typename?: 'Mutation', editGoodOption: { __typename?: 'EditGoodOptionOutput', ok: boolean, err?: string | null } };

export type EditGoodOrderMutationVariables = Exact<{
  input: EditGoodOrderInput;
}>;


export type EditGoodOrderMutation = { __typename?: 'Mutation', editGoodOrder: { __typename?: 'EditGoodOrderOutput', ok: boolean, err?: string | null } };

export type EditGoodPosterMutationVariables = Exact<{
  input: EditGoodPosterInput;
}>;


export type EditGoodPosterMutation = { __typename?: 'Mutation', editGoodPoster: { __typename?: 'EditGoodPosterOutput', ok: boolean, err?: string | null } };

export type EditGoodStatusMutationVariables = Exact<{
  input: EditGoodStatusInput;
}>;


export type EditGoodStatusMutation = { __typename?: 'Mutation', editGoodStatus: { __typename?: 'EditGoodStatusOutput', ok: boolean, err?: string | null } };

export type EditGoodsStatusMutationVariables = Exact<{
  input: EditGoodsStatusInput;
}>;


export type EditGoodsStatusMutation = { __typename?: 'Mutation', editGoodsStatus: { __typename?: 'EditGoodsStatusOutput', ok: boolean, err?: string | null } };

export type EditInquiryStatusMutationVariables = Exact<{
  input: EditInquiryStatusInput;
}>;


export type EditInquiryStatusMutation = { __typename?: 'Mutation', editInquiryStatus: { __typename?: 'EditInquiryStatusOutput', ok: boolean, err?: string | null } };

export type EditLinkServiceMutationVariables = Exact<{
  input: EditLinkServiceInput;
}>;


export type EditLinkServiceMutation = { __typename?: 'Mutation', editLinkService: { __typename?: 'EditLinkServiceOutput', ok: boolean, err?: string | null } };

export type EditMainCategoryMutationVariables = Exact<{
  input: EditMainCategoryInput;
}>;


export type EditMainCategoryMutation = { __typename?: 'Mutation', editMainCategory: { __typename?: 'EditMainCategoryOutput', ok: boolean, err?: string | null } };

export type EditNotificationSettingMutationVariables = Exact<{
  input: EditNotificationSettingInput;
}>;


export type EditNotificationSettingMutation = { __typename?: 'Mutation', editNotificationSetting: { __typename?: 'EditNotificationSettingOutput', ok: boolean, err?: string | null } };

export type EditOrderEndDateMutationVariables = Exact<{
  input: EditOrderEndDateInput;
}>;


export type EditOrderEndDateMutation = { __typename?: 'Mutation', editOrderEndDate: { __typename?: 'EditOrderEndDateOutput', ok: boolean, err?: string | null } };

export type EditOrderStatusMutationVariables = Exact<{
  input: EditOrderStatusInput;
}>;


export type EditOrderStatusMutation = { __typename?: 'Mutation', editOrderStatus: { __typename?: 'EditOrderStatusOutput', ok: boolean, err?: string | null } };

export type EditOrdersStatusReleaseMutationVariables = Exact<{
  input: EditOrdersStatusInput;
}>;


export type EditOrdersStatusReleaseMutation = { __typename?: 'Mutation', editOrdersStatusRelease: { __typename?: 'EditOrdersStatusOutput', ok: boolean, err?: string | null } };

export type EditOrderStatusWithQuantityMutationVariables = Exact<{
  input: EditOrderStatusWithQuantityInput;
}>;


export type EditOrderStatusWithQuantityMutation = { __typename?: 'Mutation', editOrderStatusWithQuantity: { __typename?: 'EditOrderStatusWithQuantityOutput', ok: boolean, err?: string | null } };

export type EditOrdersStatusMutationVariables = Exact<{
  input: EditOrdersStatusInput;
}>;


export type EditOrdersStatusMutation = { __typename?: 'Mutation', editOrdersStatus: { __typename?: 'EditOrdersStatusOutput', ok: boolean, err?: string | null } };

export type EditOrdersStatusWithQuantityMutationVariables = Exact<{
  input: EditOrdersStatusWithQuantityInput;
}>;


export type EditOrdersStatusWithQuantityMutation = { __typename?: 'Mutation', editOrdersStatusWithQuantity: { __typename?: 'EditOrdersStatusWithQuantityOutput', ok: boolean, err?: string | null } };

export type EditPortMutationVariables = Exact<{
  input: EditPortInput;
}>;


export type EditPortMutation = { __typename?: 'Mutation', editPort: { __typename?: 'EditPortOutput', ok: boolean, err?: string | null } };

export type EditProjectMutationVariables = Exact<{
  input: EditProjectInput;
}>;


export type EditProjectMutation = { __typename?: 'Mutation', editProject: { __typename?: 'EditProjectOutput', ok: boolean, err?: string | null } };

export type EditReceiptAddressMutationVariables = Exact<{
  input: EditReceiptAddressInput;
}>;


export type EditReceiptAddressMutation = { __typename?: 'Mutation', editReceiptAddress: { __typename?: 'EditReceiptAddressOutput', ok: boolean, err?: string | null } };

export type EditStaffUserMutationVariables = Exact<{
  input: EditStaffUserInput;
}>;


export type EditStaffUserMutation = { __typename?: 'Mutation', editStaffUser: { __typename?: 'EditStaffUserOutput', ok: boolean, err?: string | null } };

export type GetBannerQueryVariables = Exact<{
  input: GetBannerInput;
}>;


export type GetBannerQuery = { __typename?: 'Query', getBanner: { __typename?: 'GetBannerOutput', ok: boolean, err?: string | null, banner?: { __typename?: 'Banner', id: number, title: string } | null } };

export type GetBannerMainQueryVariables = Exact<{
  input: GetBannerMainInput;
}>;


export type GetBannerMainQuery = { __typename?: 'Query', getBannerMain: { __typename?: 'getBannerMainOutput', ok: boolean, err?: string | null, bannerMain?: { __typename?: 'BannerMain', id: number, index: number, link?: string | null, name?: string | null, mainType?: BannerMainType | null, title?: string | null, note?: string | null, alt?: string | null, isRes: boolean, isEvent: boolean, isFree: boolean, isOnePlusOne: boolean, upload?: { __typename?: 'Upload', id: number, uuid?: string | null, url?: string | null, filename: string } | null, event?: { __typename?: 'BannerMainEvent', title?: string | null, isActive: boolean, link?: string | null, upload?: { __typename?: 'Upload', id: number, uuid?: string | null, url?: string | null, filename: string } | null } | null, linkServices?: Array<{ __typename?: 'LinkService', id: number, name: string }> | null } | null } };

export type GetCorporationQueryVariables = Exact<{
  input: GetCorporationInput;
}>;


export type GetCorporationQuery = { __typename?: 'Query', getCorporation: { __typename?: 'GetCorporationOutput', ok: boolean, err?: string | null, corporation?: { __typename?: 'Corporation', id: number, createdAt?: any | null, name: string, managerName?: string | null, phone?: string | null, address?: string | null, ceoName?: string | null, amount: number, regionKeyWord?: Array<string> | null, operationFrom?: string | null, operationTo?: string | null, origin?: string | null, holiday?: string | null, deliveryLimitQuantity?: number | null, businessName?: string | null, businessNumber?: string | null, businessAddress?: string | null, linkService?: { __typename?: 'LinkService', id: number, name: string } | null, mainCategories?: Array<{ __typename?: 'MainCategory', id: number, name: string }> | null } | null } };

export type GetCouponQueryVariables = Exact<{
  input: GetCouponInput;
}>;


export type GetCouponQuery = { __typename?: 'Query', getCoupon: { __typename?: 'GetCouponOutput', ok: boolean, err?: string | null, coupon?: { __typename?: 'Coupon', id: number, name: string, code?: string | null, status: CouponStatus, scope: CouponScope, discountPrice?: number | null, usageLimit: number, userUsageLimit: number, validFrom: any, validUntil: any, createdAt?: any | null, linkService?: { __typename?: 'LinkService', id: number, name: string } | null, corporation?: { __typename?: 'Corporation', id: number, name: string } | null } | null } };

export type GetFlightQueryVariables = Exact<{
  input: GetFlightInput;
}>;


export type GetFlightQuery = { __typename?: 'Query', getFlight: { __typename?: 'GetFlightOutput', ok: boolean, err?: string | null, flight?: { __typename?: 'Flight', id: number, createdAt?: any | null, orderAt?: any | null, takeOffAt?: any | null, landAt?: any | null, note?: string | null, status?: FlightStatus | null, project?: { __typename?: 'Project', id: number, name: string } | null, drone?: { __typename?: 'Drone', id: number, name: string } | null, portTo?: { __typename?: 'Port', id: number, name: string } | null, portFrom?: { __typename?: 'Port', id: number, name: string } | null, pilotTo?: { __typename?: 'User', id: number, name?: string | null } | null, pilotFrom?: { __typename?: 'User', id: number, name?: string | null } | null, pack?: { __typename?: 'Pack', id: number } | null } | null } };

export type GetGoodQueryVariables = Exact<{
  input: GetGoodInput;
}>;


export type GetGoodQuery = { __typename?: 'Query', getGood: { __typename?: 'GetGoodOutput', ok: boolean, err?: string | null, good?: { __typename?: 'Good', id: number, tags?: Array<Tags> | null, summary?: string | null, limitNumOrders: number, title: string, status: GoodStatus, expirydate?: any | null, createdAt?: any | null, weight?: number | null, price?: number | null, discountRate?: number | null, attributeSet?: string | null, goodAttrInfo?: string | null, goodRelations?: Array<{ __typename?: 'GoodRelation', id: number, index?: number | null, relatedGoods?: Array<{ __typename?: 'Good', title: string, id: number }> | null }> | null, corporation?: { __typename?: 'Corporation', id: number, name: string } | null, goodOptions?: Array<{ __typename?: 'GoodOption', id: number, name?: string | null, desc?: string | null, isActive: boolean, deliveryDate?: any | null, discountRate?: number | null }> | null, subCategory?: { __typename?: 'SubCategory', id: number, name: string } | null } | null } };

export type GetInquiryQueryVariables = Exact<{
  input: GetInquiryInput;
}>;


export type GetInquiryQuery = { __typename?: 'Query', getInquiry: { __typename?: 'GetInquiryOutput', ok: boolean, err?: string | null, inquiry?: { __typename?: 'Inquiry', id: number, createdAt?: any | null, title: string, note: string, error?: string | null, status: InquiryStatus, type: InquiryType, inquiryPosters?: Array<{ __typename?: 'InquiryPoster', id: number, index: number, upload?: { __typename?: 'Upload', id: number, url?: string | null } | null }> | null, author: { __typename?: 'User', id: number, name?: string | null, phone?: string | null }, manager?: { __typename?: 'User', id: number, name?: string | null } | null, comments?: Array<{ __typename?: 'Comment', id: number, note: string }> | null, receipt?: { __typename?: 'Receipt', id: number, uuid?: string | null } | null } | null } };

export type GetMainCategoryQueryVariables = Exact<{
  input: GetMainCategoryInput;
}>;


export type GetMainCategoryQuery = { __typename?: 'Query', getMainCategory: { __typename?: 'GetMainCategoryOutput', ok: boolean, err?: string | null, mainCategory?: { __typename?: 'MainCategory', id: number, name: string, upload?: { __typename?: 'Upload', url?: string | null, uuid?: string | null } | null } | null } };

export type GetNotificationSettingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationSettingQuery = { __typename?: 'Query', getNotificationSetting: { __typename?: 'GetNotificationSettingOutput', ok: boolean, err?: string | null, setting?: { __typename?: 'NotificationSetting', id: number, adminNotifyPhone?: string | null, customerMessageTemplate?: string | null, orderCompleteMessageTemplate?: string | null, droneFlightMessageTemplate?: string | null } | null } };

export type GetPortQueryVariables = Exact<{
  input: GetPortInput;
}>;


export type GetPortQuery = { __typename?: 'Query', getPort: { __typename?: 'GetPortOutput', ok: boolean, err?: string | null, port?: { __typename?: 'Port', id: number, name: string, status: PortStatus, address?: string | null, usageTime?: string | null, pickUp: boolean, deliveryRegion: boolean, regionKeyWord?: Array<string> | null, phone?: string | null, project?: { __typename?: 'Project', id: number, name: string } | null, author?: { __typename?: 'User', name?: string | null, phone?: string | null } | null, linkService?: { __typename?: 'LinkService', id: number, name: string } | null } | null } };

export type GetProjectQueryVariables = Exact<{
  input: GetProjectInput;
}>;


export type GetProjectQuery = { __typename?: 'Query', getProject: { __typename?: 'GetProjectOutput', ok: boolean, err?: string | null, project?: { __typename?: 'Project', id: number, name: string, note: string, startAt?: any | null, endAt?: any | null, status?: ProjectStatus | null } | null } };

export type ListBannerQueryVariables = Exact<{
  input: ListBannerInput;
}>;


export type ListBannerQuery = { __typename?: 'Query', listBanner: { __typename?: 'ListBannerOutput', ok: boolean, err?: string | null, totalPages?: number | null, totalResults?: number | null, row?: number | null, banners?: Array<{ __typename?: 'Banner', id: number, createdAt?: any | null, title: string, isActive: boolean, bannerOptions?: Array<{ __typename?: 'BannerOption', id: number, createdAt?: any | null, link?: string | null, index: number }> | null }> | null } };

export type ListBannerMainQueryVariables = Exact<{
  input: ListBannerMainInput;
}>;


export type ListBannerMainQuery = { __typename?: 'Query', listBannerMain: { __typename?: 'ListBannerMainOutput', ok: boolean, err?: string | null, bannerMain?: Array<{ __typename?: 'BannerMain', id: number, index: number, link?: string | null, mainType?: BannerMainType | null, title?: string | null, name?: string | null, note?: string | null, alt?: string | null, isRes: boolean, isEvent: boolean, isFree: boolean, isOnePlusOne: boolean, upload?: { __typename?: 'Upload', id: number, uuid?: string | null, url?: string | null, filename: string } | null, linkServices?: Array<{ __typename?: 'LinkService', id: number, name: string }> | null }> | null } };

export type ListBannerOptionQueryVariables = Exact<{ [key: string]: never; }>;


export type ListBannerOptionQuery = { __typename?: 'Query', listBannerOption: { __typename?: 'ListBannerOptionOutput', ok: boolean, err?: string | null, bannerOptions?: Array<{ __typename?: 'BannerOption', id: number, index: number, link?: string | null, title?: string | null, note?: string | null, alt?: string | null, isActive: boolean, isRes: boolean, isEvent: boolean, isFree: boolean, isOnePlusOne: boolean, upload?: { __typename?: 'Upload', id: number, uuid?: string | null, url?: string | null, filename: string } | null }> | null } };

export type ListCommentQueryVariables = Exact<{
  input: ListCommentInput;
}>;


export type ListCommentQuery = { __typename?: 'Query', listComment: { __typename?: 'ListCommentOutput', ok: boolean, err?: string | null, comments?: Array<{ __typename?: 'Comment', id: number, createdAt?: any | null, note: string, author: { __typename?: 'User', id: number, name?: string | null }, inquiry: { __typename?: 'Inquiry', id: number } }> | null } };

export type ListCorporationQueryVariables = Exact<{
  input: ListCorporationInput;
}>;


export type ListCorporationQuery = { __typename?: 'Query', listCorporation: { __typename?: 'ListCorporationOutput', ok: boolean, err?: string | null, totalPages?: number | null, totalResults?: number | null, row?: number | null, corporations?: Array<{ __typename?: 'Corporation', id: number, name: string, managerName?: string | null, address?: string | null, operationFrom?: string | null, operationTo?: string | null, phone?: string | null, ceoName?: string | null, isActive: boolean, regionKeyWord?: Array<string> | null, mainCategories?: Array<{ __typename?: 'MainCategory', id: number, name: string }> | null, linkService?: { __typename?: 'LinkService', id: number, name: string } | null }> | null } };

export type ListCorporationSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type ListCorporationSelectQuery = { __typename?: 'Query', listCorporationSelect: { __typename?: 'ListCorporationSelectOutput', ok: boolean, err?: string | null, corporations?: Array<{ __typename?: 'Corporation', id: number, name: string }> | null } };

export type ListCouponQueryVariables = Exact<{
  input: ListCouponInput;
}>;


export type ListCouponQuery = { __typename?: 'Query', listCoupon: { __typename?: 'ListCouponOutput', ok: boolean, err?: string | null, totalPages?: number | null, totalResults?: number | null, coupons?: Array<{ __typename?: 'Coupon', id: number, name: string, code?: string | null, status: CouponStatus, scope: CouponScope, discountPrice?: number | null, usageLimit: number, userUsageLimit: number, validFrom: any, validUntil: any, createdAt?: any | null, linkService?: { __typename?: 'LinkService', id: number, name: string } | null, corporation?: { __typename?: 'Corporation', id: number, name: string } | null }> | null } };

export type ListDroneQueryVariables = Exact<{
  input: ListDroneInput;
}>;


export type ListDroneQuery = { __typename?: 'Query', listDrone: { __typename?: 'ListDroneOutput', ok: boolean, err?: string | null, totalPages?: number | null, totalResults?: number | null, row?: number | null, drones?: Array<{ __typename?: 'Drone', id: number, createdAt?: any | null, name: string, status: DroneStatus, model: DroneModel, serial?: string | null, flights?: Array<{ __typename?: 'Flight', id: number }> | null }> | null } };

export type ListDroneSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type ListDroneSelectQuery = { __typename?: 'Query', listDroneSelect: { __typename?: 'ListDroneSelectOutput', ok: boolean, err?: string | null, drones?: Array<{ __typename?: 'Drone', id: number, name: string, model: DroneModel }> | null } };

export type ListFlightQueryVariables = Exact<{
  input: ListFlightInput;
}>;


export type ListFlightQuery = { __typename?: 'Query', listFlight: { __typename?: 'ListFlightOutput', ok: boolean, err?: string | null, totalPages?: number | null, totalResults?: number | null, row?: number | null, flights?: Array<{ __typename?: 'Flight', id: number, createdAt?: any | null, takeOffAt?: any | null, flightTime?: string | null, landAt?: any | null, orderAt?: any | null, note?: string | null, status?: FlightStatus | null, pack?: { __typename?: 'Pack', id: number, orders?: Array<{ __typename?: 'Order', goodOption?: { __typename?: 'GoodOption', name?: string | null, good?: { __typename?: 'Good', title: string } | null } | null }> | null } | null, portTo?: { __typename?: 'Port', id: number, name: string } | null, portFrom?: { __typename?: 'Port', id: number, name: string } | null, pilotTo?: { __typename?: 'User', id: number, name?: string | null } | null, pilotFrom?: { __typename?: 'User', id: number, name?: string | null } | null, project?: { __typename?: 'Project', id: number, name: string, ports?: Array<{ __typename?: 'Port', author?: { __typename?: 'User', name?: string | null } | null }> | null } | null, drone?: { __typename?: 'Drone', id: number, serial?: string | null, model: DroneModel, name: string } | null }> | null } };

export type ListGoodQueryVariables = Exact<{
  input: ListGoodInput;
}>;


export type ListGoodQuery = { __typename?: 'Query', listGood: { __typename?: 'ListGoodOutput', ok: boolean, err?: string | null, totalPages?: number | null, totalResults?: number | null, row?: number | null, goods?: Array<{ __typename?: 'Good', id: number, createdAt?: any | null, title: string, price?: number | null, weight?: number | null, goodOrder?: GoodOrder | null, tags?: Array<Tags> | null, status: GoodStatus, corporation?: { __typename?: 'Corporation', id: number, name: string } | null, goodOptions?: Array<{ __typename?: 'GoodOption', deliveryDate?: any | null, expirydate?: any | null, name?: string | null, id: number }> | null, subCategory?: { __typename?: 'SubCategory', id: number, name: string } | null }> | null } };

export type ListGoodAllQueryVariables = Exact<{ [key: string]: never; }>;


export type ListGoodAllQuery = { __typename?: 'Query', listGoodAll: { __typename?: 'ListGoodAllOutput', ok: boolean, err?: string | null, goods?: Array<{ __typename?: 'Good', id: number, createdAt?: any | null, title: string, status: GoodStatus, corporation?: { __typename?: 'Corporation', id: number, name: string } | null, goodOptions?: Array<{ __typename?: 'GoodOption', deliveryDate?: any | null, expirydate?: any | null, name?: string | null, id: number }> | null }> | null } };

export type ListGoodDetailQueryVariables = Exact<{
  input: ListGoodDetailInput;
}>;


export type ListGoodDetailQuery = { __typename?: 'Query', listGoodDetail: { __typename?: 'ListGoodDetailOutput', ok: boolean, err?: string | null, goodDetails?: Array<{ __typename?: 'GoodDetail', id: number, createdAt?: any | null, index: number, note?: string | null, url?: string | null, detailType?: GoodDetailType | null, upload?: { __typename?: 'Upload', id: number, uuid?: string | null, filename: string, url?: string | null } | null, good?: { __typename?: 'Good', id: number, title: string, summary?: string | null } | null }> | null } };

export type ListGoodOptionQueryVariables = Exact<{
  input: ListGoodOptionInput;
}>;


export type ListGoodOptionQuery = { __typename?: 'Query', listGoodOption: { __typename?: 'ListGoodOptionOutput', ok: boolean, err?: string | null, goodOptions?: Array<{ __typename?: 'GoodOption', id: number, createdAt?: any | null, name?: string | null, price?: number | null, weight?: number | null, count?: number | null, goodOrder?: GoodOrder | null, expirydate?: any | null, deliveryDate?: any | null, goodOptionUuid?: string | null, dateActive: boolean, isEvent: boolean, discountRate?: number | null, corporation?: { __typename?: 'Corporation', id: number, name: string } | null, good?: { __typename?: 'Good', title: string, id: number, status: GoodStatus } | null }> | null } };

export type ListGoodPosterQueryVariables = Exact<{
  input: ListGoodPosterInput;
}>;


export type ListGoodPosterQuery = { __typename?: 'Query', listGoodPoster: { __typename?: 'ListGoodPosterOutput', ok: boolean, err?: string | null, goodPosters?: Array<{ __typename?: 'GoodPoster', id: number, createdAt?: any | null, index: number, isRep: boolean, upload?: { __typename?: 'Upload', id: number, url?: string | null } | null, good?: { __typename?: 'Good', id: number } | null }> | null } };

export type ListInquiryQueryVariables = Exact<{
  input: ListInquiryInput;
}>;


export type ListInquiryQuery = { __typename?: 'Query', listInquiry: { __typename?: 'ListInquiryOutput', ok: boolean, err?: string | null, totalPages?: number | null, totalResults?: number | null, row?: number | null, inquiries?: Array<{ __typename?: 'Inquiry', id: number, createdAt?: any | null, title: string, note: string, error?: string | null, status: InquiryStatus, type: InquiryType, author: { __typename?: 'User', id: number, phone?: string | null, username?: string | null, name?: string | null }, manager?: { __typename?: 'User', id: number } | null, comments?: Array<{ __typename?: 'Comment', id: number }> | null, receipt?: { __typename?: 'Receipt', id: number } | null }> | null } };

export type ListLinkServiceQueryVariables = Exact<{
  input: ListLinkServiceInput;
}>;


export type ListLinkServiceQuery = { __typename?: 'Query', listLinkService: { __typename?: 'ListLinkServiceOutput', ok: boolean, err?: string | null, totalPages?: number | null, totalResults?: number | null, row?: number | null, linkservice?: Array<{ __typename?: 'LinkService', id: number, name: string, minAmount?: number | null, isActive: boolean, useDeliveryFee: boolean, address?: string | null, operationFrom?: string | null, operationTo?: string | null }> | null } };

export type ListLinkServiceSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type ListLinkServiceSelectQuery = { __typename?: 'Query', listLinkServiceSelect: { __typename?: 'ListLinkServiceSelectOutput', ok: boolean, err?: string | null, linkservice?: Array<{ __typename?: 'LinkService', id: number, name: string }> | null } };

export type ListMainCategoryQueryVariables = Exact<{ [key: string]: never; }>;


export type ListMainCategoryQuery = { __typename?: 'Query', listMainCategory: { __typename?: 'ListMainCategoryOutput', ok: boolean, err?: string | null, mainCategories?: Array<{ __typename?: 'MainCategory', id: number, name: string, upload?: { __typename?: 'Upload', url?: string | null } | null }> | null } };

export type ListOrderQueryVariables = Exact<{
  input: ListOrderInput;
}>;


export type ListOrderQuery = { __typename?: 'Query', listOrder: { __typename?: 'ListOrderOutput', ok: boolean, err?: string | null, totalPages?: number | null, totalResults?: number | null, row?: number | null, orders?: Array<{ __typename?: 'Order', id: number, createdAt?: any | null, EndDate?: any | null, goodName: string, goodOptionName?: string | null, quantity: number, amount: number, orderNum?: number | null, status: OrderStatus, exchangeStatus: ExchangeStatus, redelivery?: Redelivery | null, manager?: { __typename?: 'User', id: number, name?: string | null } | null, receipt?: { __typename?: 'Receipt', id: number, uuid?: string | null, receiver?: string | null, address?: string | null, paid_amount?: number | null, deliveryFee?: number | null, receiptNum?: string | null, message?: string | null, pass?: string | null, phone?: string | null, receiptStatus: ReceiptStatus, user?: { __typename?: 'User', username?: string | null, name?: string | null, phone?: string | null } | null } | null, good?: { __typename?: 'Good', id: number, title: string, weight?: number | null, uuid?: string | null, plu?: string | null, corporation?: { __typename?: 'Corporation', id: number, name: string } | null } | null, goodOption?: { __typename?: 'GoodOption', id: number, name?: string | null, goodOptionUuid?: string | null } | null, pack?: { __typename?: 'Pack', id: number, status?: PackStatus | null } | null, orderReceipt?: { __typename?: 'OrderReceipt', order_quantity: number, order_price?: number | null, order_amount?: number | null, good_discountRate?: number | null, goodOption_name?: string | null, good_title?: string | null } | null }> | null } };

export type ListPackQueryVariables = Exact<{
  input: ListPackInput;
}>;


export type ListPackQuery = { __typename?: 'Query', listPack: { __typename?: 'ListPackOutput', ok: boolean, err?: string | null, totalPages?: number | null, totalResults?: number | null, row?: number | null, packs?: Array<{ __typename?: 'Pack', id: number, orders?: Array<{ __typename?: 'Order', id: number, orderNum?: number | null, good?: { __typename?: 'Good', id: number, title: string, goodOptions?: Array<{ __typename?: 'GoodOption', id: number, name?: string | null }> | null } | null }> | null }> | null } };

export type ListPackEditQueryVariables = Exact<{
  input: ListPackEditInput;
}>;


export type ListPackEditQuery = { __typename?: 'Query', listPackEdit: { __typename?: 'ListPackEditOutput', ok: boolean, err?: string | null, packs?: Array<{ __typename?: 'Pack', id: number, orders?: Array<{ __typename?: 'Order', orderNum?: number | null, id: number, goodOptionName?: string | null }> | null }> | null } };

export type ListPackOrderQueryVariables = Exact<{
  input: ListPackOrderInput;
}>;


export type ListPackOrderQuery = { __typename?: 'Query', listPackOrder: { __typename?: 'ListPackOrderOutput', ok: boolean, err?: string | null, orders?: Array<{ __typename?: 'Order', id: number, goodName: string, orderNum?: number | null, goodOptionName?: string | null, receipt?: { __typename?: 'Receipt', receiptNum?: string | null } | null }> | null } };

export type ListPackSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type ListPackSelectQuery = { __typename?: 'Query', listPackSelect: { __typename?: 'ListPackSelectOutput', ok: boolean, err?: string | null, packs?: Array<{ __typename?: 'Pack', id: number, orders?: Array<{ __typename?: 'Order', orderNum?: number | null, id: number, goodOptionName?: string | null }> | null }> | null } };

export type ListPortQueryVariables = Exact<{
  input: ListPortInput;
}>;


export type ListPortQuery = { __typename?: 'Query', listPort: { __typename?: 'ListPortOutput', ok: boolean, err?: string | null, totalPages?: number | null, totalResults?: number | null, row?: number | null, ports?: Array<{ __typename?: 'Port', id: number, createdAt?: any | null, name: string, status: PortStatus, flightTos?: Array<{ __typename?: 'Flight', takeOffAt?: any | null }> | null, flightFroms?: Array<{ __typename?: 'Flight', landAt?: any | null }> | null, author?: { __typename?: 'User', name?: string | null } | null, project?: { __typename?: 'Project', id: number, name: string } | null }> | null } };

export type ListPortSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type ListPortSelectQuery = { __typename?: 'Query', listPortSelect: { __typename?: 'ListPortSelectOutput', ok: boolean, err?: string | null, ports?: Array<{ __typename?: 'Port', name: string, id: number }> | null } };

export type ListProjectQueryVariables = Exact<{
  input: ListProjectInput;
}>;


export type ListProjectQuery = { __typename?: 'Query', listProject: { __typename?: 'ListProjectOutput', ok: boolean, err?: string | null, totalPages?: number | null, totalResults?: number | null, row?: number | null, projects?: Array<{ __typename?: 'Project', id: number, createdAt?: any | null, name: string, note: string, status?: ProjectStatus | null, startAt?: any | null, endAt?: any | null, flights?: Array<{ __typename?: 'Flight', id: number }> | null, ports?: Array<{ __typename?: 'Port', id: number }> | null }> | null } };

export type ListProjectSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type ListProjectSelectQuery = { __typename?: 'Query', listProjectSelect: { __typename?: 'ListProjectSelectOutput', ok: boolean, err?: string | null, projects?: Array<{ __typename?: 'Project', id: number, name: string, status?: ProjectStatus | null }> | null } };

export type ListReceiptQueryVariables = Exact<{
  input: ListReceiptInput;
}>;


export type ListReceiptQuery = { __typename?: 'Query', listReceipt: { __typename?: 'ListReceiptOutput', ok: boolean, err?: string | null, totalPages?: number | null, totalResults?: number | null, row?: number | null, receipts?: Array<{ __typename?: 'Receipt', id: number, createdAt?: any | null, uuid?: string | null, paid_amount?: number | null, paid_at?: string | null, receiver?: string | null, phone?: string | null, address?: string | null, message?: string | null, scheduledAt?: any | null, receiptNum?: string | null, pass?: string | null, isBilled: boolean, receiptStatus: ReceiptStatus, status?: string | null, user?: { __typename?: 'User', username?: string | null, name?: string | null } | null, orders?: Array<{ __typename?: 'Order', id: number, amount: number, goodOptionName?: string | null, goodName: string, quantity: number, goodOption?: { __typename?: 'GoodOption', id: number } | null, orderReceipt?: { __typename?: 'OrderReceipt', order_quantity: number, order_price?: number | null, good_title?: string | null } | null }> | null }> | null } };

export type ListStaffUserQueryVariables = Exact<{
  input: ListStaffUserInput;
}>;


export type ListStaffUserQuery = { __typename?: 'Query', listStaffUser: { __typename?: 'ListStaffUserOutput', ok: boolean, err?: string | null, totalPages?: number | null, totalResults?: number | null, users?: Array<{ __typename?: 'User', id: number, username?: string | null, name?: string | null, phone?: string | null, role: UserRole, workerType?: WorkerType | null, linkServices?: Array<{ __typename?: 'LinkService', id: number, name: string }> | null }> | null } };

export type ListSubCategoryQueryVariables = Exact<{
  input: ListSubCategoryInput;
}>;


export type ListSubCategoryQuery = { __typename?: 'Query', listSubCategory: { __typename?: 'ListSubCategoryOutput', ok: boolean, err?: string | null, subCategories?: Array<{ __typename?: 'SubCategory', id: number, name: string }> | null } };

export type ListUserSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type ListUserSelectQuery = { __typename?: 'Query', listUserSelect: { __typename?: 'ListUserSelectOutput', ok: boolean, err?: string | null, users?: Array<{ __typename?: 'User', name?: string | null, id: number }> | null } };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'LoginOutput', ok: boolean, token?: string | null, err?: string | null } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: number, name?: string | null, username?: string | null, role: UserRole, phone?: string | null, workerType?: WorkerType | null, linkServices?: Array<{ __typename?: 'LinkService', id: number, name: string }> | null } };

export type SetOrderManagerMutationVariables = Exact<{
  input: SetOrderManagerInput;
}>;


export type SetOrderManagerMutation = { __typename?: 'Mutation', setOrderManager: { __typename?: 'SetOrderManagerOutput', ok: boolean, err?: string | null } };

export type EditCouponMutationVariables = Exact<{
  input: EditCouponInput;
}>;


export type EditCouponMutation = { __typename?: 'Mutation', editCoupon: { __typename?: 'EditCouponOutput', ok: boolean, err?: string | null } };

export type UpGoodDetailUrlMutationVariables = Exact<{
  input: UpGoodDetailUrlInput;
}>;


export type UpGoodDetailUrlMutation = { __typename?: 'Mutation', upGoodDetailURL: { __typename?: 'UpGoodDetailURLOutput', ok: boolean, err?: string | null } };


export const NewOrderListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"newOrderList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newOrderList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"goodName"}},{"kind":"Field","name":{"kind":"Name","value":"goodOptionName"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"manager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"receipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"receiver"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"paid_amount"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"receiptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"good"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"pack"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<NewOrderListSubscription, NewOrderListSubscriptionVariables>;
export const OrderStatusChangedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"orderStatusChanged"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderStatusChanged"}}]}}]} as unknown as DocumentNode<OrderStatusChangedSubscription, OrderStatusChangedSubscriptionVariables>;
export const ActiveBannerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"activeBanner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActiveBannerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeBanner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<ActiveBannerMutation, ActiveBannerMutationVariables>;
export const ActiveBannerOptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"activeBannerOption"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActiveBannerOptionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeBannerOption"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<ActiveBannerOptionMutation, ActiveBannerOptionMutationVariables>;
export const CancelOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"cancelOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CancelOrderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<CancelOrderMutation, CancelOrderMutationVariables>;
export const CancelOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"cancelOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CancelOrdersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<CancelOrdersMutation, CancelOrdersMutationVariables>;
export const ChangeActiveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"changeActive"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeActiveInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeActive"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<ChangeActiveMutation, ChangeActiveMutationVariables>;
export const ChangeServiceActiveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"changeServiceActive"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeServiceActiveInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeServiceActive"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<ChangeServiceActiveMutation, ChangeServiceActiveMutationVariables>;
export const CrBannerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"crBanner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrBannerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crBanner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<CrBannerMutation, CrBannerMutationVariables>;
export const CrBannerMainDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"crBannerMain"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrBannerMainInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crBannerMain"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<CrBannerMainMutation, CrBannerMainMutationVariables>;
export const CrBannerOptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"crBannerOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crBannerOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<CrBannerOptionMutation, CrBannerOptionMutationVariables>;
export const CrCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"crComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrCommentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<CrCommentMutation, CrCommentMutationVariables>;
export const CrCorporationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"crCorporation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrCorporationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crCorporation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"createdId"}}]}}]}}]} as unknown as DocumentNode<CrCorporationMutation, CrCorporationMutationVariables>;
export const CrCouponDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"crCoupon"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrCouponInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crCoupon"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<CrCouponMutation, CrCouponMutationVariables>;
export const CrDroneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"crDrone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrDroneInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crDrone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<CrDroneMutation, CrDroneMutationVariables>;
export const CrFlightDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"crFlight"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrFlightInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crFlight"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<CrFlightMutation, CrFlightMutationVariables>;
export const CrGoodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"crGood"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrGoodInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crGood"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"createdId"}}]}}]}}]} as unknown as DocumentNode<CrGoodMutation, CrGoodMutationVariables>;
export const CrGoodBulkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"crGoodBulk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrGoodBulkInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crGoodBulk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<CrGoodBulkMutation, CrGoodBulkMutationVariables>;
export const CrGoodDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"crGoodDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrGoodDetailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crGoodDetail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<CrGoodDetailMutation, CrGoodDetailMutationVariables>;
export const CrGoodOptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"crGoodOption"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrGoodOptionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crGoodOption"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<CrGoodOptionMutation, CrGoodOptionMutationVariables>;
export const CrGoodPosterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"crGoodPoster"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrGoodPosterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crGoodPoster"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<CrGoodPosterMutation, CrGoodPosterMutationVariables>;
export const CrLinkServiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"crLinkService"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrLinkServiceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crLinkService"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<CrLinkServiceMutation, CrLinkServiceMutationVariables>;
export const CrMainCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"crMainCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrMainCategoryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crMainCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<CrMainCategoryMutation, CrMainCategoryMutationVariables>;
export const CrPackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"crPack"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrPackInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crPack"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<CrPackMutation, CrPackMutationVariables>;
export const CrPortDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"crPort"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrPortInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crPort"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<CrPortMutation, CrPortMutationVariables>;
export const CrProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"crProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrProjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<CrProjectMutation, CrProjectMutationVariables>;
export const CrStaffUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"crStaffUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CrStaffUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crStaffUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CrStaffUserMutation, CrStaffUserMutationVariables>;
export const DelBannerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"delBanner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DelBannerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delBanner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<DelBannerMutation, DelBannerMutationVariables>;
export const DelBannerMainDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"delBannerMain"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DelBannerMainInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delBannerMain"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<DelBannerMainMutation, DelBannerMainMutationVariables>;
export const DelCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"delComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DelCommentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<DelCommentMutation, DelCommentMutationVariables>;
export const DelCorporationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"delCorporation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DelCorporationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delCorporation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<DelCorporationMutation, DelCorporationMutationVariables>;
export const DelDroneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"delDrone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DelDroneInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delDrone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<DelDroneMutation, DelDroneMutationVariables>;
export const DelFlightDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"delFlight"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DelFlightInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delFlight"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<DelFlightMutation, DelFlightMutationVariables>;
export const DelGoodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"delGood"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DelGoodInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delGood"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<DelGoodMutation, DelGoodMutationVariables>;
export const DelGoodDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"delGoodDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DelGoodDetailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delGoodDetail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<DelGoodDetailMutation, DelGoodDetailMutationVariables>;
export const DelGoodOptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"delGoodOption"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DelGoodOptionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delGoodOption"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<DelGoodOptionMutation, DelGoodOptionMutationVariables>;
export const DelGoodPosterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"delGoodPoster"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DelGoodPosterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delGoodPoster"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<DelGoodPosterMutation, DelGoodPosterMutationVariables>;
export const DelInquiryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"delInquiry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DelInquiryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delInquiry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<DelInquiryMutation, DelInquiryMutationVariables>;
export const DelLinkServiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"delLinkService"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DelLinkServiceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delLinkService"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<DelLinkServiceMutation, DelLinkServiceMutationVariables>;
export const DelMainCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"delMainCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DelMainCategoryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delMainCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<DelMainCategoryMutation, DelMainCategoryMutationVariables>;
export const DelOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"delOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DelOrderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<DelOrderMutation, DelOrderMutationVariables>;
export const DelPackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"delPack"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DelPackInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delPack"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<DelPackMutation, DelPackMutationVariables>;
export const DelPackOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"delPackOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DelPackOrderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delPackOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<DelPackOrderMutation, DelPackOrderMutationVariables>;
export const DelPortDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"delPort"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DelPortInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delPort"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<DelPortMutation, DelPortMutationVariables>;
export const DelProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"delProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DelProjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<DelProjectMutation, DelProjectMutationVariables>;
export const DelUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"delUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DelUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<DelUserMutation, DelUserMutationVariables>;
export const ListDriverSelectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listDriverSelect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listDriverSelect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ListDriverSelectQuery, ListDriverSelectQueryVariables>;
export const EditBannerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editBanner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditBannerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editBanner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditBannerMutation, EditBannerMutationVariables>;
export const EditBannerMainDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editBannerMain"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditBannerMainInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editBannerMain"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditBannerMainMutation, EditBannerMainMutationVariables>;
export const EditBannerMainIndexDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editBannerMainIndex"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditBannerMainIndexInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editBannerMainIndex"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditBannerMainIndexMutation, EditBannerMainIndexMutationVariables>;
export const EditBannerOptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editBannerOption"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditBannerOptionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editBannerOption"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditBannerOptionMutation, EditBannerOptionMutationVariables>;
export const EditBusinessInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editBusinessInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditBusinessInfoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editBusinessInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditBusinessInfoMutation, EditBusinessInfoMutationVariables>;
export const EditCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditCommentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditCommentMutation, EditCommentMutationVariables>;
export const EditCorporationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editCorporation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditCorporationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editCorporation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditCorporationMutation, EditCorporationMutationVariables>;
export const EditDroneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editDrone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditDroneInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editDrone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditDroneMutation, EditDroneMutationVariables>;
export const EditExchangeStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editExchangeStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditExchangeStatusInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editExchangeStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditExchangeStatusMutation, EditExchangeStatusMutationVariables>;
export const EditFlightDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editFlight"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditFlightInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editFlight"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditFlightMutation, EditFlightMutationVariables>;
export const EditFlightStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editFlightStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditFlightStatusInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editFlightStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditFlightStatusMutation, EditFlightStatusMutationVariables>;
export const EditGoodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editGood"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditGoodInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editGood"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditGoodMutation, EditGoodMutationVariables>;
export const EditGoodAttrDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editGoodAttr"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditGoodAttrInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editGoodAttr"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditGoodAttrMutation, EditGoodAttrMutationVariables>;
export const EditGoodAttrInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editGoodAttrInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditGoodAttrInfoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editGoodAttrInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditGoodAttrInfoMutation, EditGoodAttrInfoMutationVariables>;
export const EditGoodDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editGoodDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditGoodDetailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editGoodDetail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditGoodDetailMutation, EditGoodDetailMutationVariables>;
export const EditGoodDetailIndexDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editGoodDetailIndex"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditGoodDetailIndexInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editGoodDetailIndex"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditGoodDetailIndexMutation, EditGoodDetailIndexMutationVariables>;
export const EditGoodOptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editGoodOption"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditGoodOptionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editGoodOption"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditGoodOptionMutation, EditGoodOptionMutationVariables>;
export const EditGoodOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editGoodOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditGoodOrderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editGoodOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditGoodOrderMutation, EditGoodOrderMutationVariables>;
export const EditGoodPosterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editGoodPoster"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditGoodPosterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editGoodPoster"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditGoodPosterMutation, EditGoodPosterMutationVariables>;
export const EditGoodStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editGoodStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditGoodStatusInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editGoodStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditGoodStatusMutation, EditGoodStatusMutationVariables>;
export const EditGoodsStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editGoodsStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditGoodsStatusInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editGoodsStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditGoodsStatusMutation, EditGoodsStatusMutationVariables>;
export const EditInquiryStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editInquiryStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditInquiryStatusInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editInquiryStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditInquiryStatusMutation, EditInquiryStatusMutationVariables>;
export const EditLinkServiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editLinkService"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditLinkServiceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editLinkService"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditLinkServiceMutation, EditLinkServiceMutationVariables>;
export const EditMainCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editMainCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditMainCategoryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editMainCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditMainCategoryMutation, EditMainCategoryMutationVariables>;
export const EditNotificationSettingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editNotificationSetting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditNotificationSettingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editNotificationSetting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditNotificationSettingMutation, EditNotificationSettingMutationVariables>;
export const EditOrderEndDateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editOrderEndDate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditOrderEndDateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editOrderEndDate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditOrderEndDateMutation, EditOrderEndDateMutationVariables>;
export const EditOrderStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editOrderStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditOrderStatusInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editOrderStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditOrderStatusMutation, EditOrderStatusMutationVariables>;
export const EditOrdersStatusReleaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editOrdersStatusRelease"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditOrdersStatusInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editOrdersStatusRelease"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditOrdersStatusReleaseMutation, EditOrdersStatusReleaseMutationVariables>;
export const EditOrderStatusWithQuantityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editOrderStatusWithQuantity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditOrderStatusWithQuantityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editOrderStatusWithQuantity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditOrderStatusWithQuantityMutation, EditOrderStatusWithQuantityMutationVariables>;
export const EditOrdersStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editOrdersStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditOrdersStatusInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editOrdersStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditOrdersStatusMutation, EditOrdersStatusMutationVariables>;
export const EditOrdersStatusWithQuantityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editOrdersStatusWithQuantity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditOrdersStatusWithQuantityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editOrdersStatusWithQuantity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditOrdersStatusWithQuantityMutation, EditOrdersStatusWithQuantityMutationVariables>;
export const EditPortDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editPort"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditPortInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editPort"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditPortMutation, EditPortMutationVariables>;
export const EditProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditProjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditProjectMutation, EditProjectMutationVariables>;
export const EditReceiptAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editReceiptAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditReceiptAddressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editReceiptAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditReceiptAddressMutation, EditReceiptAddressMutationVariables>;
export const EditStaffUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editStaffUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditStaffUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editStaffUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditStaffUserMutation, EditStaffUserMutationVariables>;
export const GetBannerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBanner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetBannerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBanner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"banner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<GetBannerQuery, GetBannerQueryVariables>;
export const GetBannerMainDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBannerMain"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetBannerMainInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBannerMain"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"bannerMain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mainType"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"isRes"}},{"kind":"Field","name":{"kind":"Name","value":"isEvent"}},{"kind":"Field","name":{"kind":"Name","value":"isFree"}},{"kind":"Field","name":{"kind":"Name","value":"isOnePlusOne"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkServices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBannerMainQuery, GetBannerMainQueryVariables>;
export const GetCorporationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCorporation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetCorporationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCorporation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"corporation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"managerName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"ceoName"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"regionKeyWord"}},{"kind":"Field","name":{"kind":"Name","value":"operationFrom"}},{"kind":"Field","name":{"kind":"Name","value":"operationTo"}},{"kind":"Field","name":{"kind":"Name","value":"origin"}},{"kind":"Field","name":{"kind":"Name","value":"holiday"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryLimitQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"businessNumber"}},{"kind":"Field","name":{"kind":"Name","value":"businessAddress"}},{"kind":"Field","name":{"kind":"Name","value":"linkService"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCorporationQuery, GetCorporationQueryVariables>;
export const GetCouponDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCoupon"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetCouponInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCoupon"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"coupon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"linkService"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"corporation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountPrice"}},{"kind":"Field","name":{"kind":"Name","value":"usageLimit"}},{"kind":"Field","name":{"kind":"Name","value":"userUsageLimit"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<GetCouponQuery, GetCouponQueryVariables>;
export const GetFlightDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFlight"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetFlightInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getFlight"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"flight"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"orderAt"}},{"kind":"Field","name":{"kind":"Name","value":"takeOffAt"}},{"kind":"Field","name":{"kind":"Name","value":"landAt"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"drone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"portTo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"portFrom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pilotTo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pilotFrom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pack"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetFlightQuery, GetFlightQueryVariables>;
export const GetGoodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getGood"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetGoodInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getGood"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"good"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"limitNumOrders"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"expirydate"}},{"kind":"Field","name":{"kind":"Name","value":"goodRelations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"relatedGoods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"attributeSet"}},{"kind":"Field","name":{"kind":"Name","value":"goodAttrInfo"}},{"kind":"Field","name":{"kind":"Name","value":"corporation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"desc"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryDate"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetGoodQuery, GetGoodQueryVariables>;
export const GetInquiryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInquiry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetInquiryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getInquiry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"inquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"inquiryPosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}},{"kind":"Field","name":{"kind":"Name","value":"receipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetInquiryQuery, GetInquiryQueryVariables>;
export const GetMainCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMainCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetMainCategoryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMainCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"mainCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMainCategoryQuery, GetMainCategoryQueryVariables>;
export const GetNotificationSettingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getNotificationSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getNotificationSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"setting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"adminNotifyPhone"}},{"kind":"Field","name":{"kind":"Name","value":"customerMessageTemplate"}},{"kind":"Field","name":{"kind":"Name","value":"orderCompleteMessageTemplate"}},{"kind":"Field","name":{"kind":"Name","value":"droneFlightMessageTemplate"}}]}}]}}]}}]} as unknown as DocumentNode<GetNotificationSettingQuery, GetNotificationSettingQueryVariables>;
export const GetPortDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPort"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetPortInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPort"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"port"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"usageTime"}},{"kind":"Field","name":{"kind":"Name","value":"pickUp"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryRegion"}},{"kind":"Field","name":{"kind":"Name","value":"regionKeyWord"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkService"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPortQuery, GetPortQueryVariables>;
export const GetProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetProjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"startAt"}},{"kind":"Field","name":{"kind":"Name","value":"endAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<GetProjectQuery, GetProjectQueryVariables>;
export const ListBannerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listBanner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListBannerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listBanner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}},{"kind":"Field","name":{"kind":"Name","value":"row"}},{"kind":"Field","name":{"kind":"Name","value":"banners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"bannerOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"index"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListBannerQuery, ListBannerQueryVariables>;
export const ListBannerMainDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listBannerMain"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListBannerMainInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listBannerMain"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"bannerMain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"mainType"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"isRes"}},{"kind":"Field","name":{"kind":"Name","value":"isEvent"}},{"kind":"Field","name":{"kind":"Name","value":"isFree"}},{"kind":"Field","name":{"kind":"Name","value":"isOnePlusOne"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkServices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListBannerMainQuery, ListBannerMainQueryVariables>;
export const ListBannerOptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listBannerOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listBannerOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"bannerOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"isRes"}},{"kind":"Field","name":{"kind":"Name","value":"isEvent"}},{"kind":"Field","name":{"kind":"Name","value":"isFree"}},{"kind":"Field","name":{"kind":"Name","value":"isOnePlusOne"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListBannerOptionQuery, ListBannerOptionQueryVariables>;
export const ListCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListCommentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListCommentQuery, ListCommentQueryVariables>;
export const ListCorporationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listCorporation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListCorporationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listCorporation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}},{"kind":"Field","name":{"kind":"Name","value":"row"}},{"kind":"Field","name":{"kind":"Name","value":"corporations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"managerName"}},{"kind":"Field","name":{"kind":"Name","value":"mainCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"operationFrom"}},{"kind":"Field","name":{"kind":"Name","value":"operationTo"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"ceoName"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"regionKeyWord"}},{"kind":"Field","name":{"kind":"Name","value":"linkService"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListCorporationQuery, ListCorporationQueryVariables>;
export const ListCorporationSelectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listCorporationSelect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listCorporationSelect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"corporations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ListCorporationSelectQuery, ListCorporationSelectQueryVariables>;
export const ListCouponDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listCoupon"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListCouponInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listCoupon"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"coupons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"linkService"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"corporation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountPrice"}},{"kind":"Field","name":{"kind":"Name","value":"usageLimit"}},{"kind":"Field","name":{"kind":"Name","value":"userUsageLimit"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}}]}}]} as unknown as DocumentNode<ListCouponQuery, ListCouponQueryVariables>;
export const ListDroneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listDrone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListDroneInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listDrone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}},{"kind":"Field","name":{"kind":"Name","value":"row"}},{"kind":"Field","name":{"kind":"Name","value":"drones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"serial"}},{"kind":"Field","name":{"kind":"Name","value":"flights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListDroneQuery, ListDroneQueryVariables>;
export const ListDroneSelectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listDroneSelect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listDroneSelect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"drones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"model"}}]}}]}}]}}]} as unknown as DocumentNode<ListDroneSelectQuery, ListDroneSelectQueryVariables>;
export const ListFlightDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listFlight"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListFlightInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listFlight"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}},{"kind":"Field","name":{"kind":"Name","value":"row"}},{"kind":"Field","name":{"kind":"Name","value":"flights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"takeOffAt"}},{"kind":"Field","name":{"kind":"Name","value":"flightTime"}},{"kind":"Field","name":{"kind":"Name","value":"landAt"}},{"kind":"Field","name":{"kind":"Name","value":"orderAt"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"pack"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"goodOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"good"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portTo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"portFrom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pilotTo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pilotFrom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"drone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serial"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListFlightQuery, ListFlightQueryVariables>;
export const ListGoodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listGood"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListGoodInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listGood"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}},{"kind":"Field","name":{"kind":"Name","value":"row"}},{"kind":"Field","name":{"kind":"Name","value":"goods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"goodOrder"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"corporation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryDate"}},{"kind":"Field","name":{"kind":"Name","value":"expirydate"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListGoodQuery, ListGoodQueryVariables>;
export const ListGoodAllDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listGoodAll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listGoodAll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"goods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"corporation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryDate"}},{"kind":"Field","name":{"kind":"Name","value":"expirydate"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListGoodAllQuery, ListGoodAllQueryVariables>;
export const ListGoodDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listGoodDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListGoodDetailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listGoodDetail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"goodDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"detailType"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"good"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListGoodDetailQuery, ListGoodDetailQueryVariables>;
export const ListGoodOptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listGoodOption"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListGoodOptionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listGoodOption"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"goodOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"goodOrder"}},{"kind":"Field","name":{"kind":"Name","value":"expirydate"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryDate"}},{"kind":"Field","name":{"kind":"Name","value":"goodOptionUuid"}},{"kind":"Field","name":{"kind":"Name","value":"dateActive"}},{"kind":"Field","name":{"kind":"Name","value":"isEvent"}},{"kind":"Field","name":{"kind":"Name","value":"discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"corporation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"good"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListGoodOptionQuery, ListGoodOptionQueryVariables>;
export const ListGoodPosterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listGoodPoster"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListGoodPosterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listGoodPoster"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"goodPosters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"index"}},{"kind":"Field","name":{"kind":"Name","value":"isRep"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"good"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListGoodPosterQuery, ListGoodPosterQueryVariables>;
export const ListInquiryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listInquiry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListInquiryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listInquiry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}},{"kind":"Field","name":{"kind":"Name","value":"row"}},{"kind":"Field","name":{"kind":"Name","value":"inquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"receipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListInquiryQuery, ListInquiryQueryVariables>;
export const ListLinkServiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listLinkService"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListLinkServiceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listLinkService"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}},{"kind":"Field","name":{"kind":"Name","value":"row"}},{"kind":"Field","name":{"kind":"Name","value":"linkservice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"minAmount"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"useDeliveryFee"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"operationFrom"}},{"kind":"Field","name":{"kind":"Name","value":"operationTo"}}]}}]}}]}}]} as unknown as DocumentNode<ListLinkServiceQuery, ListLinkServiceQueryVariables>;
export const ListLinkServiceSelectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listLinkServiceSelect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listLinkServiceSelect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"linkservice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ListLinkServiceSelectQuery, ListLinkServiceSelectQueryVariables>;
export const ListMainCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listMainCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listMainCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"mainCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListMainCategoryQuery, ListMainCategoryQueryVariables>;
export const ListOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListOrderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}},{"kind":"Field","name":{"kind":"Name","value":"row"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"EndDate"}},{"kind":"Field","name":{"kind":"Name","value":"goodName"}},{"kind":"Field","name":{"kind":"Name","value":"goodOptionName"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"orderNum"}},{"kind":"Field","name":{"kind":"Name","value":"manager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"receipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"receiver"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"paid_amount"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryFee"}},{"kind":"Field","name":{"kind":"Name","value":"receiptNum"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"pass"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"receiptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"good"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"corporation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"goodOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"goodOptionUuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeStatus"}},{"kind":"Field","name":{"kind":"Name","value":"pack"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"redelivery"}},{"kind":"Field","name":{"kind":"Name","value":"orderReceipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"order_price"}},{"kind":"Field","name":{"kind":"Name","value":"order_amount"}},{"kind":"Field","name":{"kind":"Name","value":"good_discountRate"}},{"kind":"Field","name":{"kind":"Name","value":"goodOption_name"}},{"kind":"Field","name":{"kind":"Name","value":"good_title"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListOrderQuery, ListOrderQueryVariables>;
export const ListPackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listPack"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListPackInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listPack"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}},{"kind":"Field","name":{"kind":"Name","value":"row"}},{"kind":"Field","name":{"kind":"Name","value":"packs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderNum"}},{"kind":"Field","name":{"kind":"Name","value":"good"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"goodOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListPackQuery, ListPackQueryVariables>;
export const ListPackEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listPackEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListPackEditInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listPackEdit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"packs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderNum"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"goodOptionName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListPackEditQuery, ListPackEditQueryVariables>;
export const ListPackOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listPackOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListPackOrderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listPackOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"goodName"}},{"kind":"Field","name":{"kind":"Name","value":"orderNum"}},{"kind":"Field","name":{"kind":"Name","value":"goodOptionName"}},{"kind":"Field","name":{"kind":"Name","value":"receipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"receiptNum"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListPackOrderQuery, ListPackOrderQueryVariables>;
export const ListPackSelectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listPackSelect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listPackSelect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"packs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderNum"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"goodOptionName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListPackSelectQuery, ListPackSelectQueryVariables>;
export const ListPortDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listPort"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListPortInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listPort"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}},{"kind":"Field","name":{"kind":"Name","value":"row"}},{"kind":"Field","name":{"kind":"Name","value":"ports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"flightTos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"takeOffAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flightFroms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"landAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListPortQuery, ListPortQueryVariables>;
export const ListPortSelectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listPortSelect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listPortSelect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"ports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ListPortSelectQuery, ListPortSelectQueryVariables>;
export const ListProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListProjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}},{"kind":"Field","name":{"kind":"Name","value":"row"}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"startAt"}},{"kind":"Field","name":{"kind":"Name","value":"endAt"}},{"kind":"Field","name":{"kind":"Name","value":"flights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListProjectQuery, ListProjectQueryVariables>;
export const ListProjectSelectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listProjectSelect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listProjectSelect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<ListProjectSelectQuery, ListProjectSelectQueryVariables>;
export const ListReceiptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listReceipt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListReceiptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listReceipt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}},{"kind":"Field","name":{"kind":"Name","value":"row"}},{"kind":"Field","name":{"kind":"Name","value":"receipts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"paid_amount"}},{"kind":"Field","name":{"kind":"Name","value":"paid_at"}},{"kind":"Field","name":{"kind":"Name","value":"receiver"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledAt"}},{"kind":"Field","name":{"kind":"Name","value":"receiptNum"}},{"kind":"Field","name":{"kind":"Name","value":"pass"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isBilled"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"goodOptionName"}},{"kind":"Field","name":{"kind":"Name","value":"goodName"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"goodOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderReceipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_quantity"}},{"kind":"Field","name":{"kind":"Name","value":"order_price"}},{"kind":"Field","name":{"kind":"Name","value":"good_title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"receiptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<ListReceiptQuery, ListReceiptQueryVariables>;
export const ListStaffUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listStaffUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListStaffUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listStaffUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"workerType"}},{"kind":"Field","name":{"kind":"Name","value":"linkServices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListStaffUserQuery, ListStaffUserQueryVariables>;
export const ListSubCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listSubCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListSubCategoryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listSubCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"subCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ListSubCategoryQuery, ListSubCategoryQueryVariables>;
export const ListUserSelectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listUserSelect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listUserSelect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ListUserSelectQuery, ListUserSelectQueryVariables>;
export const LoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoginInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const MeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"workerType"}},{"kind":"Field","name":{"kind":"Name","value":"linkServices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<MeQuery, MeQueryVariables>;
export const SetOrderManagerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setOrderManager"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetOrderManagerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setOrderManager"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<SetOrderManagerMutation, SetOrderManagerMutationVariables>;
export const EditCouponDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editCoupon"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditCouponInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editCoupon"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<EditCouponMutation, EditCouponMutationVariables>;
export const UpGoodDetailUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upGoodDetailURL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpGoodDetailURLInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upGoodDetailURL"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"err"}}]}}]}}]} as unknown as DocumentNode<UpGoodDetailUrlMutation, UpGoodDetailUrlMutationVariables>;